package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.NoLiveLiterals
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import waldo.sankan.lineamunicipalkmp.model.Administrador
import waldo.sankan.lineamunicipalkmp.model.Comuna
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import waldo.sankan.lineamunicipalkmp.model.Noticia
import waldo.sankan.lineamunicipalkmp.model.TipoIncidencia
import waldo.sankan.lineamunicipalkmp.web.services.FirebaseWebService
import kotlin.js.Date
import androidx.compose.runtime.Stable
import waldo.sankan.lineamunicipalkmp.model.DelitoTipificado
import waldo.sankan.lineamunicipalkmp.model.EstadisticasOficiales2021Repository
import waldo.sankan.lineamunicipalkmp.model.EstadisticasOficiales2022Repository
import waldo.sankan.lineamunicipalkmp.model.EstadisticasOficiales2023Repository
import waldo.sankan.lineamunicipalkmp.model.EstadisticasOficiales2024Repository
import waldo.sankan.lineamunicipalkmp.model.EstadisticasOficiales2025Repository
import waldo.sankan.lineamunicipalkmp.model.HistoricoRepository
import waldo.sankan.lineamunicipalkmp.model.Sector
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD
import waldo.sankan.lineamunicipalkmp.model.TipificacionesDao
import waldo.sankan.lineamunicipalkmp.model.UsuarioSolucionador
import kotlinx.browser.window
import kotlin.collections.component1
import kotlin.collections.component2
import kotlin.text.uppercase

@Serializable
data class SimpleMarker(
    val id: String, 
    val lat: Double, 
    val lng: Double, 
    val estado: String, 
    val tipoIncidenciaDisplayName: String,
    val descripcion: String = "" // 🎯 SANKAN UPGRADE: Info activa en el mapa
)

data class KpiValue(
    val valorActual: Double = 0.0,
    val valorAnterior: Double = 0.0,
    val variacion: Double = 0.0
)

data class DashboardKpis(
    val kpiDrogas: KpiValue = KpiValue(),
    val kpiRobos: KpiValue = KpiValue(),
    val kpiVif: KpiValue = KpiValue(),
    val kpiAmenazas: KpiValue = KpiValue(),
    val kpiEbriedad: KpiValue = KpiValue(),
    val kpiVifDetenidos: Double = 0.0
)

data class EstadisticasResumen(
    val total: Int = 0,
    val solucionadas: Int = 0,
    val enProceso: Int = 0,
    val rechazadas: Int = 0,
    val verificadas: Int = 0,
    val tiempoPromedioSolucionMs: Double = 0.0
)

data class EstadisticasPorTipo(
    val tipoIncidencia: String,
    val resumen: EstadisticasResumen
)

data class EstadisticasMensuales(
    val mes: String,
    val resumenGeneral: EstadisticasResumen,
    val desglosePorTipo: List<EstadisticasPorTipo>
)

// --- Data class para una sola línea de estadística ---
data class DesgloseEstadistico(
    val total: Int = 0,
    val solucionado: Int = 0,
    val enProceso: Int = 0,
    val rechazado: Int = 0,
    val verificado: Int = 0
)

// --- El contenedor principal de nuestras estadísticas de delitos ---
data class EstadisticasDelitos(
    val totalIncidenciasUnicas: Int = 0, // <-- ¡NUEVO CAMPO DE INTELIGENCIA!
    val resumenGeneral: DesgloseEstadistico = DesgloseEstadistico(),
    val desglosePorGrupo: Map<String, DesgloseEstadistico> = emptyMap(),
    val desglosePorDelito: Map<String, DesgloseEstadistico> = emptyMap()
)

// --- ¡NUEVO ARMAMENTO PARA EL ANUARIO HISTÓRICO! ---

// Almacena una sola entrada del historial, ej: "2021-2022", "-15.3%"
data class KpiVariacionAnual(
    val periodo: String,
    val variacion: Double
)

// Contiene la inteligencia completa para una tarjeta de KPI
data class KpiDetallado(
    val nombre: String,
    val historicoAnual: List<KpiVariacionAnual> = emptyList()
    // Aquí, en el futuro, irán los datos para el gráfico de barras
)

data class KpiPeriodo(val id: String, val nombre: String, val meses: IntRange)

@Stable
data class AdminPanelUiState(
    private var todasLasIncidenciasMaestra: List<Incidencia> = emptyList(),
    val comunas: List<Comuna> = emptyList(),
    val tiposIncidencia: List<TipoIncidencia> = emptyList(),
    val showDuplicadosModal: Boolean = false,
    val listaDuplicadosModal: List<Incidencia> = emptyList(),
    val mensajeParaCiudadano: String = "",
    val mensajeParaSolucionador: String = "",
    val mensajeParaAdmin: String = "",
    val mensajeParaDron: String = "",
    val estadisticas: List<EstadisticasMensuales> = emptyList(),
    val estadisticaAnual: EstadisticasMensuales? = null,
    val estadisticasDelitos: EstadisticasDelitos? = null,
    val fechaInicioEstadisticas: Long? = null,
    val fechaFinEstadisticas: Long? = null,
    val filtroMesEstadisticas: String? = "ANUAL",
    val filtroMesEstadisticasGenerales: String? = "ANUAL",
    val mapMarkersJson: String = "[]",
    val fechaInicioSeleccionada: Long? = null,
    val fechaFinSeleccionada: Long? = null,
    val isLoadingGlobal: Boolean = false,
    val filtroGrupoDelito: String? = null,
    val markersSeguridadJson: String = "[]",
    val markersJson: String = "[]",
    val incidencias: List<Incidencia> = emptyList(),
    val isLoading: Boolean = true,
    val isLoadingHistoricos: Boolean = false,
    val error: String? = null,
    val isUploadingPhoto: Boolean = false,
    val selectedIncidencia: Incidencia? = null,
    val catalogoDisponibleParaDetalle: List<DelitoTipificado> = emptyList(),
    val rolAdmin: Administrador? = null,
    val delitosCatalog: List<DelitoTipificado> = emptyList(),
    val daoCatalog: List<DelitoTipificado> = emptyList(),
    val filtroEstado: String? = null,
    val filtroComuna: String? = null,
    val filtroTipo: String? = null,
    val ordenPorFecha: String = "Recientes",
    val filtroMes: String? = null,
    val filtroRegionEstadisticas: String? = "TODAS",
    val filtroComunaEstadisticas: String? = "TODAS",
    val mesesDisponibles: List<String> = emptyList(),
    val incidenciasInformeSeguridad: List<Incidencia> = emptyList(),

    // Banderas de Navegación
    val showMapView: Boolean = false,
    val showEstadisticasView: Boolean = false,
    val showDroneView: Boolean = false,
    val showCamerasView: Boolean = false, // <-- ¡NUEVO SENSOR!
    val showInformeView: Boolean = false,
    val showEstadisticasSeguridadView: Boolean = false,
    val showInformeSeguridadView: Boolean = false,
    val showIngresoIncidenciaView: Boolean = false,
    val showGestionPatrullasView: Boolean = false,
    val showDashboardSeguridadView: Boolean = false, // ¡LA BANDERA PARA NUESTRO DASHBOARD!
    val showNoticiasView: Boolean = false, // --- ¡EL CABALLO DE TROYA! ---

    // Estado para Gestión de Patrullas
    val solucionadores: List<UsuarioSolucionador> = emptyList(),
    val sectores: List<Sector> = emptyList(),
    val showAgregarPatrullaModal: Boolean = false,

    // Contexto para Gestión de Patrullas
    val patrullaContextoRef: String = "",
    val patrullaContextoDisplayName: String = "",
    val patrullaComunaRef: String? = null,
    val patrullaComunaNombre: String? = null,


    val kpiAnioPrincipal: Int = 2026,
    val kpiFiltroSector: String? = "TODOS",
    val kpiFechaInicioActual: Long? = null,
    val kpiFechaFinActual: Long? = null,
    val kpiAnioComparacion: Int = 2025,
    val kpiMesInicioComparacion: Int = 1,
    val kpiMesFinComparacion: Int = 1, // Corregido de 3 a 1 para que tenga sentido por defecto
    val kpiPeriodosDisponibles: List<KpiPeriodo> = emptyList(),
    val kpiPeriodoSeleccionado: String = "t1", // Trimestre 1 por defecto
    val dashboardKpis: DashboardKpis? = null,
    val kpisDetallados: List<KpiDetallado> = emptyList(),
    val selectedIncidenciaDron: Incidencia? = null,
    var catalogoDelitos: List<DelitoTipificado> = emptyList(),
    val showGestionDelitosView: Boolean = false,
    val showGestionComunasView: Boolean = false,
    val showAgregarSectorModal: Boolean = false,
    val showGestionServiciosView: Boolean = false,
    val imagenSeleccionada: org.w3c.files.File? = null,
    val showAgregarServicioModal: Boolean = false,
    val showEditarServicioModal: Boolean = false,
    val servicioAEditar: TipoIncidencia? = null,

    // 🚩 Banderas de Soberanía (Tri-Soberanía)
    val isSalvavidasSelected: Boolean = false,
    val isDaoSelected: Boolean = false,
    val isSeguridadSelected: Boolean = false,
    val modoServiciosUrbanos: Boolean = false, // Control de mando para Gestión Urbana
    val historialNoticias: List<Noticia> = emptyList(), // --- ¡HISTORIAL DE COMUNICADOS! ---
    val sectoresComuna: List<Sector> = emptyList(), // Sectores para segmentación
    
    // --- 🌍 ESCALABILIDAD NACIONAL ---
    val regiones: List<waldo.sankan.lineamunicipalkmp.model.Region> = emptyList(),
    val filtroRegion: String? = null,
    val filtroComunaGestion: String? = null, // Filtro específico para pantallas de gestión

    // --- 🏛️ GESTIÓN DE GABINETE (CREDENCIALES) ---
    val showGestionGabineteView: Boolean = false,
    val gabineteAdmins: List<Administrador> = emptyList(),
    val selectedComunaGabineteRef: String? = null,
    val selectedComunaGabineteNombre: String? = null,

    // --- 📢 MANDO CENTRAL: COMUNICADOS ---
    val avisoNacional: dynamic = null,
    val showPlanCuadranteModal: Boolean = false,
)

// --- Contenedor de datos para el ingreso manual ---
data class NuevaIncidenciaManual(
    val nombreCiudadano: String,
    val rutCiudadano: String,
    val direccion: String,
    val descripcion: String,
    val lat: Double?,
    val lng: Double?,
    val tipoIncidenciaDisplayName: String,
    val tipoIncidenciaRef: String,
    val comunaDisplayName: String,
    val comunaRef: String,
    val regionDisplayName: String?,
    val regionRef: String?,
    val idUsuarioSolucionadorAsignado: String?,
    val observacionSolucionador: String?,
    val usuarioAuthUid: String,
    val showCamerasView: Boolean = false, // <-- ¡NUEVA LÍNEA PARA EL ESTADO!


)






@Stable
class AdminPanelViewModel(val adminProfile: Administrador, private val onSessionClosed: () -> Unit)
{
        private val viewModelScope = CoroutineScope(Dispatchers.Default)
        private val webService = FirebaseWebService()

        private val _uiState = MutableStateFlow(AdminPanelUiState())
        val uiState = _uiState.asStateFlow()

        var todasLasIncidenciasMaestra: List<Incidencia> =
            emptyList() // ¡Nuestra copia de seguridad!

        fun contarHijos(padreId: String): Int {
            return _uiState.value.incidencias.count { it.padreId == padreId }
        }


        val incidenciasFiltradas: StateFlow<List<Incidencia>> = _uiState.map { state ->
            // 1. Partimos de la lista que YA FUE FILTRADA POR ROL al cargar
            val incidenciasBase = state.incidencias

            // 2. Aplicamos el filtro de MES sobre esa base
            val incidenciasPorMes = if (state.filtroMes == null) {
                incidenciasBase
            } else {
                incidenciasBase.filter { inc ->
                    inc.fechaCreacion?.let {
                        val fecha = Date(it)
                        val mesIncidencia = "${fecha.getFullYear()}-${
                            (fecha.getMonth() + 1).toString().padStart(2, '0')
                        }"
                        mesIncidencia == state.filtroMes
                    } ?: false
                }
            }

            // 3. Aplicamos los filtros restantes sobre el resultado anterior
            val filtered = incidenciasPorMes.filter { incidencia ->
                val estadoMatch =
                    state.filtroEstado == null || incidencia.estado == state.filtroEstado
                val comunaMatch =
                    state.filtroComuna == null || incidencia.comunaDisplayName == state.filtroComuna
                val tipoMatch =
                    state.filtroTipo == null || incidencia.tipoIncidenciaDisplayName == state.filtroTipo
                
                // 🛡️ FILTRO DE DUPLICADOS: Ocultamos los duplicados hijos para mantener la tabla limpia
                val noEsDuplicadoHijo = !incidencia.marcadoComoDuplicado

                estadoMatch && comunaMatch && tipoMatch && noEsDuplicadoHijo
            }

            // 4. Ordenamos el resultado final
            if (state.ordenPorFecha == "Antiguas") {
                filtered.sortedBy { it.fechaCreacion }
            } else {
                filtered.sortedByDescending { it.fechaCreacion }
            }
        }.stateIn(
            scope = viewModelScope,
            started = SharingStarted.Eagerly,
            initialValue = emptyList()
        )


        val mapMarkersJson: StateFlow<String> = incidenciasFiltradas.map { filteredList ->
            val markersData = filteredList.mapNotNull { incidencia ->
                // 🛡️ REPARACIÓN RADAR: Fallback a ubicación de solución si no hay reporte GPS original
                val gps = incidencia.ubicacionGPS ?: incidencia.ubicacionGPSSolucion
                gps?.let {
                    SimpleMarker(
                        id = incidencia.id,
                        lat = it.latitude,
                        lng = it.longitude,
                        estado = incidencia.estado,
                        tipoIncidenciaDisplayName = incidencia.tipoIncidenciaDisplayName ?: "N/A",
                        descripcion = incidencia.descripcion
                    )
                }
            }
            Json.encodeToString(markersData)
        }.stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), "[]")


    // --- ¡NUEVO MOTOR DE INTELIGENCIA PARA EL MAPA DE SEGURIDAD! (VERSIÓN CORREGIDA) ---
    // --- 🛡️ MOTOR DE INTELIGENCIA REACTIVA PARA EL MAPA DE SEGURIDAD (FIX RUPTURA DE SINCRONIZACIÓN) ---
    val mapMarkersSeguridadJson: StateFlow<String> = combine(_uiState, incidenciasFiltradas) { state, baseList ->
        // 1. Usamos baseList (ya filtrada por estado/mes/etc) para evitar condiciones de carrera
        val incidenciasDeSeguridad = baseList.filter {
            it.tipoIncidenciaDisplayName == "Seguridad Ciudadana"
        }

        // 2. Aplicamos el filtro por GRUPO de delito sobre lo ya filtrado
        val finalFiltradas = if (state.filtroGrupoDelito == null) {
            incidenciasDeSeguridad
        } else {
            incidenciasDeSeguridad.filter { incidencia ->
                incidencia.tipificacionesDelito.any { delito ->
                    waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(delito)?.grupo == state.filtroGrupoDelito
                }
            }
        }

        // 3. Conversión a JSON para JS
        val markersData = finalFiltradas.mapNotNull { incidencia ->
            incidencia.ubicacionGPS?.let { gps ->
                SimpleMarker(
                    id = incidencia.id,
                    lat = gps.latitude,
                    lng = gps.longitude,
                    estado = incidencia.estado,
                    tipoIncidenciaDisplayName = incidencia.tipoIncidenciaDisplayName ?: "N/A",
                    descripcion = incidencia.descripcion
                )
            }
        }
        Json.encodeToString(markersData)
    }.stateIn(viewModelScope, SharingStarted.Eagerly, "[]")

    // --- ¡NUEVO COMANDO TÁCTICO! ---
    fun onFiltroGrupoDelitoChanged(grupo: String?) {
        _uiState.update { it.copy(filtroGrupoDelito = grupo) }
    }



        init {
            val filterComuna = if (adminProfile.rol == "GENERAL") null else adminProfile.comunaAsignadaRef
            viewModelScope.launch {
                fetchAllData()
                inicializarPeriodosKpi()
                cargarCatalogoDelitos()

                webService.listenToIncidencias(comunaRef = filterComuna) { nuevasIncidencias ->
                    // --- ¡DETECCIÓN DE NUEVA INCIDENCIA (Radar Sonoro)! ---
                    if (todasLasIncidenciasMaestra.isNotEmpty() && nuevasIncidencias.size > todasLasIncidenciasMaestra.size) {
                        console.log("Radar Web: ¡Nueva incidencia detectada! Disparando alerta sonora.")
                        playAlertSound()
                    }

                    todasLasIncidenciasMaestra = nuevasIncidencias
                    // 2. Procesamos y recalculamos todo automáticamente
                    actualizarEstadoConNuevosDatos(nuevasIncidencias)
                    
                    // 🛡️ REPARACIÓN TÁCTICA: Disparar estadísticas generales al recibir datos en vivo
                    val filtradas = filtrarIncidenciasPorAutoridad(nuevasIncidencias)
                    calcularEstadisticasGenerales(filtradas)
                    calcularEstadisticasDelitos(filtradas)
                }
            }
        }


    private fun inicializarPeriodosKpi() {
        // --- ¡EL CEREBRO DE NUESTRA MÁQUINA DEL TIEMPO! ---
        val hoy = Date()
        // getMonth() es 0-indexado, así que Enero es 0. Sumamos 1 para lógica 1-12.
        val mesActual = hoy.getMonth() + 1

        val periodosDinamicos = mutableListOf<KpiPeriodo>()

        // 1. Añadimos los MESES que ya han terminado.
        if (mesActual > 1) periodosDinamicos.add(KpiPeriodo("enero", "Enero", 1..1))
        if (mesActual > 2) periodosDinamicos.add(KpiPeriodo("febrero", "Febrero", 2..2))
        if (mesActual > 3) periodosDinamicos.add(KpiPeriodo("marzo", "Marzo", 3..3))
        if (mesActual > 4) periodosDinamicos.add(KpiPeriodo("abril", "Abril", 4..4))
        if (mesActual > 5) periodosDinamicos.add(KpiPeriodo("mayo", "Mayo", 5..5))
        if (mesActual > 6) periodosDinamicos.add(KpiPeriodo("junio", "Junio", 6..6))
        if (mesActual > 7) periodosDinamicos.add(KpiPeriodo("julio", "Julio", 7..7))
        if (mesActual > 8) periodosDinamicos.add(KpiPeriodo("agosto", "Agosto", 8..8))
        if (mesActual > 9) periodosDinamicos.add(KpiPeriodo("septiembre", "Septiembre", 9..9))
        if (mesActual > 10) periodosDinamicos.add(KpiPeriodo("octubre", "Octubre", 10..10))
        if (mesActual > 11) periodosDinamicos.add(KpiPeriodo("noviembre", "Noviembre", 11..11))
        if (mesActual > 12) periodosDinamicos.add(KpiPeriodo("diciembre", "Diciembre", 12..12))

        // 2. Añadimos los TRIMESTRES que ya han terminado.
        if (mesActual > 3) periodosDinamicos.add(KpiPeriodo("t1", "Trimestre 1 (Ene-Mar)", 1..3))
        if (mesActual > 6) periodosDinamicos.add(KpiPeriodo("t2", "Trimestre 2 (Abr-Jun)", 4..6))
        if (mesActual > 9) periodosDinamicos.add(KpiPeriodo("t3", "Trimestre 3 (Jul-Sep)", 7..9))
        // El T4 solo está disponible cuando el año termina (mes > 12, o sea, en el siguiente año)
        if (mesActual > 12) periodosDinamicos.add(KpiPeriodo("t4", "Trimestre 4 (Oct-Dic)", 10..12))

        // 3. Establecemos un valor por defecto inteligente.
        // Será el último período disponible, o un valor por defecto si la lista está vacía (ej. en Enero).
        val periodoPorDefecto = periodosDinamicos.lastOrNull()?.id ?: "enero"

        // 4. Actualizamos el estado de la UI
        _uiState.update {
            it.copy(
                kpiPeriodosDisponibles = periodosDinamicos.reversed(), // Mostramos los más recientes primero
                kpiPeriodoSeleccionado = periodoPorDefecto
            )
        }
    }

    // --- 🛡️ LLAVE DE FILTRADO MAESTRA (DOCTRINA UNIFICADA) ---
    private fun filtrarIncidenciasPorAutoridad(maestra: List<Incidencia>): List<Incidencia> {
        val rolDB = (adminProfile.rol ?: "").uppercase().trim()
        val uidRolAdmin = adminProfile.uidRol
        // 🛡️ REGLA DE ORO DE WALDO: Todos los especialistas operan bajo la lógica DAO
        val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA", "SALVAVIDAS")

        val maestraFiltrada = maestra // 🛡️ LIBERACIÓN TOTAL: Leemos todo para que no se pierda nada por nombre antiguo

        return when {
            rolDB == "GENERAL" -> maestraFiltrada
            rolDB == "COMUNAL" || rolDB == "OPERADORA" || rolDB == "OPERADOR_DRON" || rolDB == "OPERADOR_CAMARAS" -> {
                // 🛡️ REPARACIÓN SANKAN: ID PURO para match con Apps M1
                val idLimpio = (adminProfile.comunaAsignadaRef ?: "").split("/").last().trim().uppercase()
                val miNombre = (adminProfile.comunaAsignadaDisplayName ?: "").trim().uppercase()
                
                maestraFiltrada.filter { inc ->
                    val incRef = (inc.comunaRef ?: "").split("/").last().trim().uppercase()
                    val incNombre = (inc.comunaDisplayName ?: "").trim().uppercase()
                    // Buscamos coincidencia exacta con el ID puro o el nombre
                    incRef == idLimpio || incNombre == miNombre
                }
            }
            rolDB == "DIRECCION_DAO" -> {
                // 🛡️ REPARACIÓN SANKAN: El Director DAO solo ve su comuna y solo tipos DAO (Filtro Positivo)
                val idLimpio = (adminProfile.comunaAsignadaRef ?: "").split("/").last().trim().uppercase()
                val miNombre = (adminProfile.comunaAsignadaDisplayName ?: "").trim().uppercase()

                maestraFiltrada.filter { inc ->
                    val incRef = (inc.comunaRef ?: "").split("/").last().trim().uppercase()
                    val incNombre = (inc.comunaDisplayName ?: "").trim().uppercase()
                    val matchComuna = incRef == idLimpio || incNombre == miNombre

                    val disp = inc.tipoIncidenciaDisplayName?.uppercase() ?: ""
                    // 🎯 FILTRO POSITIVO DAO: Solo permitimos los 5 servicios urbanos oficiales
                    val esTipoDAO = disp.contains("BASURA") || disp.contains("ASEO") || 
                                   disp.contains("BACHE") || disp.contains("PAVIMENTO") ||
                                   disp.contains("ILUMINA") || disp.contains("LUZ") ||
                                   disp.contains("SEM") || disp.contains("AUTO") || disp.contains("VEHICULO")
                    
                    matchComuna && esTipoDAO
                }
            }
            rolDB == "DIRECCION_DAO" -> {
                // 🛡️ MANDO DE DIRECCIÓN: DAO es la única con visión transversal por ahora
                val idLimpio = (adminProfile.comunaAsignadaRef ?: "").split("/").last().trim().uppercase()
                val miNombre = (adminProfile.comunaAsignadaDisplayName ?: "").trim().uppercase()
                
                maestraFiltrada.filter { inc ->
                    val incRef = (inc.comunaRef ?: "").split("/").last().trim().uppercase()
                    val incNombre = (inc.comunaDisplayName ?: "").trim().uppercase()
                    val matchComuna = incRef == idLimpio || incNombre == miNombre

                    val tRaw = (inc.tipoIncidenciaDisplayName ?: "").uppercase()
                    val tipoEnCatalogo = _uiState.value.tiposIncidencia.find { 
                        it.id == inc.tipoIncidenciaRef || (it.nombreDisplay ?: it.nombre).uppercase() == tRaw
                    }
                    val matchPorDepto = tipoEnCatalogo?.departamento?.uppercase() == "DAO"
                    val matchPorNombre = tRaw.contains("BASURA") || tRaw.contains("ASEO") || tRaw.contains("BACHE") || tRaw.contains("ILUMINA") || tRaw.contains("SEMAFORO") || tRaw.contains("AUTO")
                    
                    matchComuna && (matchPorDepto || matchPorNombre)
                }
            }
            rolDB == "SEGURIDAD_ADMIN" || rolDB == "SOCIAL_ADMIN" || rolDB == "EMERGENCIA_CARRETERA" || rolDB == "SEGURIDAD_ADULTO_MAYOR" || rolDB == "SALVAVIDAS" || !uidRolAdmin.isNullOrBlank() -> {
                // 🛡️ MANDO DE SERVICIO ESPECÍFICO: Cada uno en su carril
                val idLimpio = (adminProfile.comunaAsignadaRef ?: "").split("/").last().trim().uppercase()
                val miNombre = (adminProfile.comunaAsignadaDisplayName ?: "").trim().uppercase()
                
                maestraFiltrada.filter { inc ->
                    val incRef = (inc.comunaRef ?: "").split("/").last().trim().uppercase()
                    val incNombre = (inc.comunaDisplayName ?: "").trim().uppercase()
                    val matchComuna = incRef == idLimpio || incNombre == miNombre

                    val tRaw = (inc.tipoIncidenciaDisplayName ?: "").uppercase()
                    
                    // Match por ID técnico O por coincidencia estricta de nombre
                    val matchPorID = !uidRolAdmin.isNullOrBlank() && inc.tipoIncidenciaRef == uidRolAdmin
                    val matchPorNombre = when(rolDB) {
                        "SOCIAL_ADMIN" -> tRaw.contains("SOCIAL") && !tRaw.contains("ADULTO")
                        "SEGURIDAD_ADMIN" -> tRaw == "SEGURIDAD CIUDADANA"
                        "EMERGENCIA_CARRETERA" -> tRaw.contains("SOS") || tRaw.contains("CARRETERA")
                        "SEGURIDAD_ADULTO_MAYOR" -> tRaw.contains("ADULTO") || tRaw.contains("MAYOR")
                        "SALVAVIDAS" -> tRaw.contains("SALVAVI") || tRaw.contains("PLAYA")
                        else -> tRaw.contains(rolDB.replace("_", " "))
                    }
                    
                    matchComuna && (matchPorID || matchPorNombre)
                }
            }

            else -> maestra.filter { it.tipoIncidenciaDisplayName?.uppercase()?.contains(rolDB) == true }
        }
    }
    fun fetchAllData() {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, error = null) }
            try {
                val state = _uiState.value
                val filterComuna = if (adminProfile.rol == "GENERAL") null else adminProfile.comunaAsignadaRef
                val todasLasComunas = webService.fetchAllComunas()
                val todasLasRegiones = webService.fetchAllRegiones() // --- NUEVO SUMINISTRO ---
                
                val comunasData = if (adminProfile.rol == "GENERAL") {
                    todasLasComunas
                } else {
                    // 🛡️ REPARACIÓN: El admin comunal debe ver su comuna SIEMPRE para que el servicio no se bloquee
                    val miIdLimpio = adminProfile.comunaAsignadaRef?.split("/")?.last() ?: ""
                    todasLasComunas.filter { it.estaActiva || it.id == miIdLimpio }
                }

                // 🛡️ REPARACIÓN SOBERANÍA: El Admin General ahora filtra sus servicios estrictamente 
                // por la comuna seleccionada o por el nivel Nacional para ver la Parrilla Maestra.
                val idComunaFiltro = if (adminProfile.rol == "GENERAL") {
                     val comunaSeleccionadaNombre = state.filtroComunaGestion ?: state.filtroComuna
                     when {
                         state.filtroRegion == "NIVEL NACIONAL (MOLDES)" -> "GLOBAL"
                         comunaSeleccionadaNombre != null && comunaSeleccionadaNombre != "Todos" -> {
                             val comObj = comunasData.find { it.comunaDisplayName == comunaSeleccionadaNombre }
                             comObj?.id
                         }
                         else -> "GLOBAL"
                     }
                } else adminProfile.comunaAsignadaRef

                val masterTipos = webService.fetchAllTiposIncidencia(comunaRef = idComunaFiltro)
                val miRol = (adminProfile.rol ?: "").uppercase().trim()
                val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA", "SALVAVIDAS")

                val tiposFinales = when {
                    miRol == "GENERAL" || miRol == "COMUNAL" || miRol == "OPERADORA" || miRol == "OPERADOR_DRON" || miRol == "OPERADOR_CAMARAS" -> masterTipos
                    miRol == "DIRECCION_DAO" -> masterTipos.filter { 
                        // 🛡️ SANKAN PROTOCOL: Filtro Pura Sangre por Departamento
                        it.departamento == "DAO"
                    }
                    miRol == "SEGURIDAD_ADMIN" -> masterTipos.filter { (it.nombreDisplay ?: it.nombre).uppercase().contains("SEGURIDAD") }
                    else -> masterTipos.filter { (it.nombreDisplay ?: it.nombre).uppercase().contains(miRol) }
                }

                val master = webService.fetchAllIncidencias(comunaRef = filterComuna)
                todasLasIncidenciasMaestra = master

                val filtradas = filtrarIncidenciasPorAutoridad(master)

                val meses = master.mapNotNull { it.fechaCreacion }
                    .map { val d = Date(it); "${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}" }
                    .distinct().sortedDescending()

                val aviso = webService.fetchAvisoNacional()

                _uiState.update { it.copy(
                    comunas = comunasData,
                    regiones = todasLasRegiones, // --- REGISTRO NACIONAL ---
                    tiposIncidencia = tiposFinales,
                    incidencias = filtradas,
                    mesesDisponibles = meses,
                    rolAdmin = adminProfile,
                    avisoNacional = aviso,
                    isLoading = false,
                    // 🛡️ REPARACIÓN RADAR: Sincronización automática de Mapa para especialistas
                    filtroTipo = if (miRol == "SEGURIDAD_ADMIN") "Seguridad Ciudadana" else null
                ) }

                calcularEstadisticasGenerales(filtradas)
                calcularEstadisticasDelitos(filtradas)
                calcularKpisHistoricos()

        } catch (e: Exception) {
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        error = e.message ?: "Ocurrió un error desconocido"
                    )
                }
            }
        }
    }


    // --- ¡EL MOTOR DE ESTADÍSTICAS, AHORA CON TRADUCTOR! ---
// --- ¡EL MOTOR DE ESTADÍSTICAS, AHORA CON TRADUCTOR! ---
        fun onFiltroMesEstadisticasChanged(mes: String?) {
        viewModelScope.launch {
            _uiState.update { it.copy(filtroMesEstadisticas = mes, isLoading = true) }
            recalcularEstadisticasConFiltrosActuales()
        }
    }
    fun onIncidenciaSelected(incidencia: Incidencia?) {
        if (incidencia == null) {
            _uiState.update { it.copy(selectedIncidencia = null, catalogoDisponibleParaDetalle = emptyList(), error = null) }
            return
        }

        // 🛡️ EXTRACCIÓN Y NORMALIZACIÓN (Para ignorar acentos y mayúsculas)
        val ref = incidencia.tipoIncidenciaRef ?: ""
        val displayOriginal = incidencia.tipoIncidenciaDisplayName ?: ""
        val d = displayOriginal.uppercase()
            .replace("Á", "A").replace("É", "E").replace("Í", "I")
            .replace("Ó", "O").replace("Ú", "U")

        // 🔍 DETECCIÓN DE FAMILIA DAO (Urbana)
        val esBasura = ref == "Xx9dXIOJmX6NQgc2a2kj" || ref.startsWith("basura") || d.contains("BASURA") || d.contains("ASEO")
        val esBache = ref == "3eTWqMVPWYP3imsojTXp" || ref.startsWith("bache") || d.contains("BACHE")
        val esLuz = ref == "65tR5EDkoLz8VKu062Zx" || ref.startsWith("ilumina") || d.contains("ILUMINA")
        val esSemaforo = ref == "QfPdJJfAMM6PjMXeivJu" || ref.startsWith("semaforo") || d.contains("SEMAFORO")
        val esAuto = ref == "kL2Ddyw20OJHsX3iOnNA" || ref.startsWith("auto") || d.contains("AUTO")
        
        val esSalvavidas = ref == "YXJTANA7o0GGw8OgOHsI" || ref.startsWith("salvavida") || d.contains("SALVAVI") || d.contains("PLAYA")
        val esSeguridadCiudadana = d == "SEGURIDAD CIUDADANA"

        // 🎯 LÓGICA DE SOBERANÍA EXTENDIDA: Si no es Seguridad Ciudadana, es un servicio del catálogo "DAO/Especialistas"
        val esServicioEspecialista = !esSeguridadCiudadana

        // 🎯 SELECCIÓN DE CATÁLOGO CON RESPALDO POR FAMILIA
        val catalogoParaEsteDetalle = when {
            esSalvavidas -> {
                val base = _uiState.value.daoCatalog.ifEmpty { TipificacionesDao.listaMaestraDao }
                base.filter { it.familia == "SALVAVIDAS" }
            }
            esServicioEspecialista -> {
                // Para cualquier otro especialista (Basura, SOS, Social, Adulto Mayor, etc.)
                val base = _uiState.value.daoCatalog.ifEmpty { TipificacionesDao.listaMaestraDao }
                
                // 🔍 ESTRATEGIA DE VÍNCULO DOBLE: 
                // 1. Buscamos por Familia canónica
                val familiaBuscada = when {
                    esBasura -> "BASURA"
                    esBache -> "BACHE"
                    esLuz -> "ILUMINACION"
                    esSemaforo -> "SEMAFORO"
                    esAuto -> "AUTO_ABANDONADO"
                    d.contains("SOCIAL") -> "SOCIAL"
                    d.contains("ADULTO") -> "ADULTO_MAYOR"
                    d.contains("SOS") || d.contains("EMERGENCIA") || d.contains("CARRETERA") -> "EMERGENCIA"
                    else -> ""
                }
                
                // 2. Filtramos la base: misma familia O vinculado al mismo ID de tipo de incidencia
                val filtrado = base.filter { it.familia == familiaBuscada || it.tipoIncidenciaRef == ref }
                
                // 3. Fallback: Si no hay nada filtrado, mostramos el catálogo DAO completo por si las moscas
                if (filtrado.isEmpty()) base else filtrado
            }
            else -> {
                // SOBERANÍA SEGURIDAD: Catálogo CEAD completo
                _uiState.value.delitosCatalog.ifEmpty { TipificacionesRepositoryCEAD.listaMaestraDeDelitos }
            }
        }

        _uiState.update {
            it.copy(
                selectedIncidencia = incidencia,
                catalogoDisponibleParaDetalle = catalogoParaEsteDetalle,
                // 🛡️ Banderas de Soberanía para la UI
                isSalvavidasSelected = esSalvavidas,
                isDaoSelected = esServicioEspecialista, // Tratamos a todos los especialistas como modo DAO (Tipificación simple)
                isSeguridadSelected = esSeguridadCiudadana,

                showMapView = false,
                showEstadisticasView = false,
                showInformeView = false,
                showCamerasView = false,
                showDroneView = false,
                showIngresoIncidenciaView = false,
                showGestionPatrullasView = false,
                showDashboardSeguridadView = false,
                showGestionDelitosView = false,
                showGestionServiciosView = false
            )
        }
    }
    fun onShowMapClicked() {
        _uiState.update {
            it.copy(
                showMapView = true,
                filtroTipo = null, // Por defecto en "Todos"
                filtroEstado = null, // Por defecto en "Todos"
                filtroMes = null, // Por defecto en "Todos"
                filtroGrupoDelito = null,
                selectedIncidencia = null,
                showEstadisticasView = false,
                showInformeView = false,
                showCamerasView = false,
                showDroneView = false
            )
        }
    }

    fun onMapBackClicked() {
        _uiState.update { it.copy(showMapView = false) }
    }

    fun abrirModalDuplicados(padreId: String) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                val padreDoc = webService.fetchIncidenciaById(padreId)
                val hijos = webService.fetchChildIncidents(padreId)
                val listaTotal = listOfNotNull(padreDoc) + hijos
                _uiState.update { it.copy(
                    isLoading = false,
                    showDuplicadosModal = true,
                    listaDuplicadosModal = listaTotal
                ) }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error cargando duplicados: ${e.message}") }
            }
        }
    }

    fun cerrarModalDuplicados() {
        _uiState.update { it.copy(showDuplicadosModal = false, listaDuplicadosModal = emptyList()) }
    }

    fun desvincularIncidencia(incidenciaId: String, padreIdAntiguo: String?) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                webService.desvincularIncidencia(incidenciaId, padreIdAntiguo)
                val master = webService.fetchAllIncidencias(null)
                todasLasIncidenciasMaestra = master
                actualizarEstadoConNuevosDatos(master)
                if (!padreIdAntiguo.isNullOrBlank()) {
                    abrirModalDuplicados(padreIdAntiguo)
                } else {
                    cerrarModalDuplicados()
                }
                _uiState.update { it.copy(isLoading = false) }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error al desvincular: ${e.message}") }
            }
        }
    }

    fun vincularIncidenciaManual(incidenciaId: String) {
        val padreIdInput = window.prompt("Ingrese el ID del caso Padre al cual desea vincular este reporte:", "")
        if (!padreIdInput.isNullOrBlank()) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    webService.vincularIncidencia(incidenciaId, padreIdInput.trim())
                    val master = webService.fetchAllIncidencias(null)
                    todasLasIncidenciasMaestra = master
                    actualizarEstadoConNuevosDatos(master)
                    _uiState.update { it.copy(isLoading = false) }
                    window.alert("✅ ¡Reporte vinculado exitosamente al caso $padreIdInput!")
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al vincular: ${e.message}") }
                }
            }
        }
    }

    fun onFiltroEstadoChanged(estado: String?) {
        _uiState.update { it.copy(filtroEstado = estado) }
    }

    fun onFiltroComunaChanged(comuna: String?) {
        _uiState.update { it.copy(filtroComuna = if (comuna == "") null else comuna) }
        // 🔄 Refrescamos el catálogo y los servicios cuando el Admin General cambia la comuna
        if ((adminProfile.rol ?: "").uppercase() == "GENERAL") {
            cargarCatalogoDelitos()
            fetchAllData() // Esto refresca tiposIncidencia filtrados
            
            // 🛡️ VERIFICACIÓN ADN MAESTRO: Si la comuna seleccionada no tiene servicios, sugerimos siembra
            verificarYProponerSiembra()
        }
    }

    // --- 🌍 NUEVOS COMANDOS DE ESCALABILIDAD ---
    fun onFiltroRegionChanged(regionNombre: String?) {
        val esNivelNacional = regionNombre == "NIVEL NACIONAL (MOLDES)"
        
        _uiState.update { 
            it.copy(
                filtroRegion = if (regionNombre == "") null else regionNombre,
                filtroComunaGestion = null // Reseteamos la comuna al cambiar de región
            ) 
        }

        if (esNivelNacional) {
            // 🛡️ GATILLO INMEDIATO: Si es Nacional, cargamos los moldes GLOBAL ahora mismo
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                val moldes = webService.fetchAllTiposIncidencia(comunaRef = "GLOBAL")
                _uiState.update { it.copy(tiposIncidencia = moldes, isLoading = false) }
                // También cargamos los catálogos globales
                cargarCatalogoDelitos()
            }
        } else {
            // Al cambiar a una región real, limpiamos y esperamos que elija comuna
            _uiState.update { it.copy(tiposIncidencia = emptyList(), delitosCatalog = emptyList(), daoCatalog = emptyList()) }
        }
    }

    fun onFiltroComunaGestionChanged(comunaNombre: String?) {
        val comunaFinal = if (comunaNombre == "") null else comunaNombre
        _uiState.update { it.copy(filtroComunaGestion = comunaFinal) }
        
        if (comunaFinal != null) {
            // Cuando elige la comuna final, cargamos sus datos específicos con ruta completa
            val comunaObj = _uiState.value.comunas.find { it.comunaDisplayName == comunaFinal }
            val ref = if (comunaObj != null) "comunas/${comunaObj.id}" else null
            
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                val tiposFinales = webService.fetchAllTiposIncidencia(comunaRef = ref)
                
                _uiState.update { it.copy(tiposIncidencia = tiposFinales, isLoading = false) }
                cargarCatalogoDelitos()
            }
        }
    }

    private fun verificarYProponerSiembra() {
        val state = _uiState.value
        if (state.filtroComuna != null && state.tiposIncidencia.isEmpty()) {
            console.log("⚠️ ADN Maestro: Comuna ${state.filtroComuna} sin servicios. Activando protocolo de siembra.")
            // Aquí podríamos disparar un diálogo o sembrar directamente si es política de la empresa
        }
    }

    fun onFiltroTipoChanged(tipo: String?) {
        _uiState.update { it.copy(filtroTipo = tipo) }
    }

    fun onFiltroMesChanged(mes: String?) {
        // ¡YA NO VAMOS A LA BASE DE DATOS!
        // Simplemente actualizamos el estado. El 'incidenciasFiltradas' hará el resto.
        _uiState.update { it.copy(filtroMes = mes) }
    }

    fun onOrdenChanged(orden: String) {
        _uiState.update { it.copy(ordenPorFecha = orden) }
    }

    fun onDroneIncidenciaSelected(incidencia: Incidencia?) {
        _uiState.update { it.copy(selectedIncidenciaDron = incidencia, error = null) }
    }

    fun onUploadDronePhoto(incidenciaId: String, file: org.w3c.files.File) {
        viewModelScope.launch {
            _uiState.update { it.copy(isUploadingPhoto = true, error = null) }
            try {
                val downloadUrl = webService.uploadDroneVerificationPhoto(incidenciaId, file)
                val updates = mapOf("urlImagenVerificacionDron" to downloadUrl)
                webService.actualizarIncidencia(incidenciaId, updates)

                // ¡AHORA ESPERAMOS A QUE EL REFRESCÓ TERMINE!
                refrescarDatosYSeleccion(incidenciaId)

                // SOLO DESPUÉS DE QUE TODO HA TERMINADO, DECLARAMOS VICTORIA.
                _uiState.update { it.copy(isUploadingPhoto = false) }

            } catch (e: Exception) {
                _uiState.update {
                    it.copy(
                        isUploadingPhoto = false,
                        error = "Error al subir la foto: ${e.message}"
                    )
                }
            }
        }
    }


    fun changeIncidenciaStatus(incidenciaId: String, nuevoEstado: String, evidenciaFile: org.w3c.files.File? = null) {
        viewModelScope.launch {
            try {
                // 1. OBTENEMOS LA INTELIGENCIA ACTUAL
                val incidenciaActual = _uiState.value.incidencias.find { it.id == incidenciaId }
                if (incidenciaActual == null) {
                    _uiState.update { it.copy(error = "No se pudo encontrar la incidencia para actualizar.") }
                    return@launch
                }

                // VALIDACIÓN DE EVIDENCIA OBLIGATORIA PARA SOLUCIONADO
                if (nuevoEstado == "SOLUCIONADO" && evidenciaFile == null && incidenciaActual.urlImagenSolucion == null) {
                    _uiState.update { it.copy(error = "La evidencia fotográfica es obligatoria para marcar como SOLUCIONADO.") }
                    return@launch
                }

                _uiState.update { it.copy(isLoadingGlobal = true, error = null) }

                // 2. ¡PREPARAMOS EL PLAN DE ATAQUE!
                val datosParaActualizar = mutableMapOf<String, Any?>("estado" to nuevoEstado)

                // CARGA DE IMAGEN SI EXISTE
                if (evidenciaFile != null) {
                    try {
                        val downloadUrl = webService.uploadSolutionPhoto(incidenciaId, evidenciaFile)
                        datosParaActualizar["urlImagenSolucion"] = downloadUrl
                    } catch (e: Exception) {
                        _uiState.update { it.copy(isLoadingGlobal = false, error = "Error al subir la evidencia: ${e.message}") }
                        return@launch
                    }
                }

                // 3. ¡LA LÓGICA DEL RELOJ DE COMBATE MEJORADA!
                when {
                    // CASO A: Se está solucionando por primera vez
                    nuevoEstado == "SOLUCIONADO" && incidenciaActual.estado != "SOLUCIONADO" -> {
                        val fechaSolucion = Date.now()
                        val fechaCreacion = (incidenciaActual.fechaCreacion as? Double) ?: fechaSolucion
                        val duracion = fechaSolucion - fechaCreacion

                        datosParaActualizar["fechaSolucion"] = fechaSolucion
                        datosParaActualizar["duracionSolucionMs"] = if (duracion > 0) duracion else 0.0
                    }
                    // CASO B: Se está "re-abriendo" una incidencia que ya estaba solucionada
                    nuevoEstado != "SOLUCIONADO" && incidenciaActual.estado == "SOLUCIONADO" -> {
                        datosParaActualizar["fechaSolucion"] = null
                        datosParaActualizar["duracionSolucionMs"] = null
                    }
                }

                // 4. ¡FUEGO! Usamos nuestra función de actualización genérica.
                webService.actualizarIncidencia(incidenciaId, datosParaActualizar)

                // Refrescamos localmente
                refrescarDatosYSeleccion(incidenciaId)

                _uiState.update { it.copy(isLoadingGlobal = false, error = null) }

            } catch (e: Exception) {
                _uiState.update { it.copy(isLoadingGlobal = false, error = "Error al cambiar estado: ${e.message}") }
            }
        }
    }




        fun onMensajeParaCiudadanoChanged(mensaje: String) {
            _uiState.update { it.copy(mensajeParaCiudadano = mensaje) }
        }

        fun onMensajeParaSolucionadorChanged(mensaje: String) {
            _uiState.update { it.copy(mensajeParaSolucionador = mensaje) }
        }

        fun enviarMensajeAlCiudadano(incidenciaId: String) {
            val mensaje = _uiState.value.mensajeParaCiudadano
            if (mensaje.isBlank()) return
            viewModelScope.launch {
                try {
                    webService.addComentarioToIncidencia(incidenciaId, mensaje, "ADMINISTRADOR")
                    _uiState.update { it.copy(mensajeParaCiudadano = "") }
                    // --- ¡DOCTRINA UNIFICADA! ---
                    refrescarDatosYSeleccion(incidenciaId)
                } catch (e: Exception) {
                    _uiState.update { it.copy(error = "Error al enviar el mensaje: ${e.message}") }
                }
            }
        }


        fun enviarMensajeAlSolucionador(incidenciaId: String) {
            val mensaje = _uiState.value.mensajeParaSolucionador
            if (mensaje.isBlank()) return
            viewModelScope.launch {
                try {
                    webService.addComentarioToIncidencia(
                        incidenciaId,
                        mensaje,
                        "ADMIN_TO_SOLUCIONADOR"
                    )
                    _uiState.update { it.copy(mensajeParaSolucionador = "") }
                    // --- ¡DOCTRINA UNIFICADA! ---
                    refrescarDatosYSeleccion(incidenciaId)
                } catch (e: Exception) {
                    _uiState.update { it.copy(error = "Error al enviar el mensaje: ${e.message}") }
                }
            }
        }

    // --- ¡NUEVO CANAL DE COMUNICACIONES DEDICADO AL DRON! ---

    fun onMensajeParaDronChanged(mensaje: String) {
        _uiState.update { it.copy(mensajeParaDron = mensaje) }
    }

    fun enviarMensajeAlDron(incidenciaId: String) {
        // Usamos un rol claro para saber que el Admin le habla al Dron
        val rolUsuario = "ADMIN_TO_DRON"
        val mensaje = _uiState.value.mensajeParaDron
        if (mensaje.isBlank()) return

        viewModelScope.launch {
            try {
                webService.addComentarioToIncidencia(incidenciaId, mensaje, rolUsuario)
                _uiState.update { it.copy(mensajeParaDron = "") } // Limpia el cuadro
                refrescarDatosYSeleccion(incidenciaId) // Refresca para ver el mensaje enviado
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error al enviar mensaje al dron: ${e.message}") }
            }
        }
    }


        // --- NUEVO CONTROL PARA ESTADÍSTICAS GENERALES ---
    fun onFiltroRegionEstadisticasChanged(region: String?) {
        viewModelScope.launch {
            _uiState.update { it.copy(
                filtroRegionEstadisticas = region ?: "TODAS",
                filtroComunaEstadisticas = "TODAS", // Reseteamos comuna al cambiar región
                isLoading = true 
            ) }
            recalcularEstadisticasConFiltrosActuales()
        }
    }

    fun onFiltroComunaEstadisticasChanged(comuna: String?) {
        viewModelScope.launch {
            _uiState.update { it.copy(filtroComunaEstadisticas = comuna ?: "TODAS", isLoading = true) }
            recalcularEstadisticasConFiltrosActuales()
        }
    }

    fun onFiltroMesEstadisticasGeneralesChanged(mes: String?) {
        viewModelScope.launch {
            _uiState.update { 
                it.copy(
                    filtroMesEstadisticasGenerales = mes, 
                    fechaInicioSeleccionada = null, 
                    fechaFinSeleccionada = null,
                    isLoading = true 
                ) 
            }
            recalcularEstadisticasConFiltrosActuales()
        }
    }

    private fun recalcularEstadisticasConFiltrosActuales() {
        val state = _uiState.value
        
        // 🛡️ REPARACIÓN: Detectar qué período usar según la vista activa
        val mes = if (state.showEstadisticasSeguridadView) state.filtroMesEstadisticas else state.filtroMesEstadisticasGenerales

        val comuna = state.filtroComunaEstadisticas
        val inicioManual = state.fechaInicioSeleccionada
        val finManual = state.fechaFinSeleccionada

        var filtradas = todasLasIncidenciasMaestra

        // 1. Filtro de Mes OR Rango Manual
        if (mes != null && mes != "ANUAL") {
            filtradas = filtradas.filter { inc ->
                inc.fechaCreacion?.let {
                    val fecha = Date(it)
                    val mesIncidencia = "${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}"
                    mesIncidencia == mes
                } ?: false
            }
        } else if (inicioManual != null && finManual != null) {
            filtradas = filtradas.filter { inc ->
                val fechaIncidencia = (inc.fechaCreacion as? Long) ?: (inc.fechaCreacion as? Double)?.toLong() ?: 0L
                fechaIncidencia in inicioManual..finManual
            }
        }

        // 🛡️ REPARACIÓN RADAR REGIONAL (LÓGICA DE CONTRATO POR COMUNA):
        // 1. Si hay una comuna específica, filtramos por ella (Soberanía Comunal).
        if (comuna != null && comuna != "TODAS") {
            filtradas = filtradas.filter { it.comunaDisplayName == comuna }
        } 
        // 2. Si hay Región pero NO Comuna, vaciamos la lista para forzar selección de comuna.
        // Esto evita mostrar totales regionales incompletos por falta de etiquetas en datos antiguos.
        else if (state.filtroRegionEstadisticas != null && state.filtroRegionEstadisticas != "TODAS") {
            filtradas = emptyList()
        }
        // 3. Si no hay nada seleccionado (Todas/Todas), mostramos el Total Nacional.

        // 🛡️ REPARACIÓN TÁCTICA: Asegurar que se respete el filtro de autoridad (BASURA/ASEO/etc)
        val filtradasPorAutoridad = filtrarIncidenciasPorAutoridad(filtradas)

        _uiState.update { it.copy(incidencias = filtradasPorAutoridad, incidenciasInformeSeguridad = filtradasPorAutoridad, isLoading = false) } // Actualizamos la lista filtrada para el reporte

        calcularEstadisticasGenerales(filtradasPorAutoridad)
        calcularEstadisticasDelitos(filtradasPorAutoridad)
    }

        // --- NUEVO MOTOR DE CÁLCULO GENERAL ---
        private fun calcularEstadisticasGenerales(incidenciasParaCalcular: List<Incidencia>) {
            if (incidenciasParaCalcular.isEmpty()) {
                _uiState.update { it.copy(estadisticas = emptyList(), isLoading = false) }
                return
            }

            // --- CÁLCULO DEL RESUMEN GENERAL ---
            val total = incidenciasParaCalcular.size
            val solucionadas = incidenciasParaCalcular.count { it.estado == "SOLUCIONADO" }
            val rechazadas = incidenciasParaCalcular.count { it.estado == "RECHAZADO" }
            val verificadas = incidenciasParaCalcular.count { it.estado == "VERIFICADO" }
            // "EN_PROCESO" y el antiguo "ASIGNADO" se cuentan ambos como "En Proceso"
            val enProceso = incidenciasParaCalcular.count { it.estado == "EN_PROCESO" || it.estado == "ASIGNADO" }

            val incidenciasConDuracion =
                incidenciasParaCalcular.mapNotNull { it.duracionSolucionMs }
            val tiempoPromedio =
                if (incidenciasConDuracion.isNotEmpty()) incidenciasConDuracion.average() else 0.0
            val resumenGeneral = EstadisticasResumen(
                total,
                solucionadas,
                enProceso,
                rechazadas,
                verificadas,
                tiempoPromedio
            )


            val desglosePorTipo = incidenciasParaCalcular
                .groupBy {
                    val rolesDao = listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "DIRECCION_DAO")
                    val adminEsDao = adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true ||
                                     (adminProfile.rol ?: "").contains("DAO", ignoreCase = true) ||
                                     adminProfile.rol in rolesDao
                    val comunaEsDao = it.comunaDisplayName?.uppercase()?.contains("DAO") == true
                    val esDaoIncidencia = adminEsDao || comunaEsDao
                    
                    val tRaw = (it.tipoIncidenciaDisplayName ?: "OTRO").trim().uppercase()
                    
                    // 🛡️ REGLA DE ORO: Si es "SERVICIO MUNICIPAL", es ruido de sistema, no un tipo ciudadano real.
                    if (tRaw.contains("SERVICIO MUNICIPAL")) return@groupBy "DESCARTADO"

                    // Normalización de tildes para evitar duplicados como "ILUMINACIÓN" vs "ILUMINACION"
                    val tNorm = tRaw.replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U")

                    // 1. Normalizar a una categoría "Canónica" basada en palabras clave o catálogo DAO
                    // 🛡️ DOCTRINA DE FAMILIAS: Elevamos la tipificación a nivel de Familia para evitar ruido.
                    val categoriaKeyword = when {
                        tNorm.contains("BASURA") || tNorm.contains("ASEO") || tNorm.contains("BARRIDO") || tNorm.contains("ESCOMBRO") -> "BASURA"
                        tNorm.contains("ILUMINA") || tNorm.contains("LUMINARIA") || tNorm.contains("LUZ") -> "ILUMINACION"
                        tNorm.contains("BACHE") || tNorm.contains("HOYO") || tNorm.contains("PAVIMENTO") || tNorm.contains("EVENTO") -> "BACHE"
                        tNorm.contains("SEMAFORO") -> "SEMAFORO"
                        tNorm.contains("AUTO") || tNorm.contains("VEHICULO") -> "AUTO_ABANDONADO"
                        tNorm.contains("SALVAVI") || tNorm.contains("PLAYA") -> "SALVAVIDAS"
                        else -> {
                            // Si no hay keyword, buscamos si alguna tipificación nos da la familia del catálogo DAO (Búsqueda Robusta)
                            it.tipificacionesDelito.firstNotNullOfOrNull { tip ->
                                val tNormTip = tip.uppercase().trim().replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U")
                                TipificacionesDao.listaMaestraDao.find { it.nombre.uppercase().trim().replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U") == tNormTip }?.familia
                            }
                        }
                    }

                    val nombreBase = (categoriaKeyword ?: tRaw).uppercase().trim()
                        .replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U")
                        .replace(" ", "_").replace("-", "_")

                    // 2. Aplicar formato consistente para evitar duplicados en la misma tabla
                    if (esDaoIncidencia) {
                        when (nombreBase) {
                            "BASURA" -> "Basura"
                            "ILUMINACION" -> "Iluminación"
                            "BACHE" -> "Baches"
                            "SEMAFORO" -> "Semáforos"
                            "AUTO_ABANDONADO" -> "Autos Abandonados"
                            "SALVAVIDAS" -> "Salvavidas"
                            else -> nombreBase.replace("_", " ").lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                        }
                    } else {
                        when (nombreBase) {
                            "BASURA" -> "Basura"
                            "ILUMINACION" -> "Iluminación"
                            "BACHE" -> "Baches"
                            "SEMAFORO" -> "Semáforos"
                            "AUTO_ABANDONADO" -> "Autos Abandonados"
                            "SALVAVIDAS" -> "Salvavidas"
                            else -> nombreBase.replace("_", " ").lowercase().replaceFirstChar { char -> if (char.isLowerCase()) char.titlecase() else char.toString() }
                        }
                    }
                }

                .filter { it.key != "DESCARTADO" && it.key != "SEGURIDAD CIUDADANA" && it.key != "Seguridad Ciudadana" }
                .map { (tipo, incidenciasDeEsteTipo) ->
                    val totalTipo = incidenciasDeEsteTipo.size
                    val solucionadasTipo = incidenciasDeEsteTipo.count { it.estado == "SOLUCIONADO" }
                    val rechazadasTipo = incidenciasDeEsteTipo.count { it.estado == "RECHAZADO" }
                    val verificadasTipo = incidenciasDeEsteTipo.count { it.estado == "VERIFICADO" }
                    val enProcesoTipo = incidenciasDeEsteTipo.count { it.estado == "EN_PROCESO" || it.estado == "ASIGNADO" }

                    val duracionesTipo = incidenciasDeEsteTipo.mapNotNull { it.duracionSolucionMs }
                    val tiempoPromedioTipo =
                        if (duracionesTipo.isNotEmpty()) duracionesTipo.average() else 0.0
                    EstadisticasPorTipo(
                        tipoIncidencia = tipo,
                        resumen = EstadisticasResumen(
                            totalTipo,
                            solucionadasTipo,
                            enProcesoTipo,
                            rechazadasTipo,
                            verificadasTipo,
                            tiempoPromedioTipo
                        )
                    )
                }

            // --- CONSTRUCCIÓN DEL OBJETO FINAL ---
            val nombrePeriodo = _uiState.value.filtroMesEstadisticasGenerales?.let {
                if (it == "ANUAL") "Resumen Anual"
                else {
                    val (year, month) = it.split("-")
                    Date(year.toInt(), month.toInt() - 1).toLocaleString(
                        "es-CL",
                        options = js("{'month': 'long', 'year': 'numeric'}")
                    ).capitalize()
                }
            } ?: "Estadísticas"

            val estadisticasFinales = listOf(
                EstadisticasMensuales(
                    mes = nombrePeriodo,
                    resumenGeneral = resumenGeneral,
                    desglosePorTipo = desglosePorTipo.sortedByDescending { it.resumen.total }
                )
            )

            _uiState.update { it.copy(estadisticas = estadisticasFinales, isLoading = false) }
        }


        fun onShowEstadisticasClicked() {
            val filtradas = filtrarIncidenciasPorAutoridad(todasLasIncidenciasMaestra)
            // Aseguramos que el motor de delitos también se sincronice con el modo DIMAO si es DAO
            calcularEstadisticasDelitos(filtradas)

            _uiState.update {
                it.copy(
                    showEstadisticasView = true,
                    selectedIncidencia = null,
                    showMapView = false,
                    showInformeView = false,
                    showDroneView = false,
                    showEstadisticasSeguridadView = false,
                    showInformeSeguridadView = false,
                    showDashboardSeguridadView = false
                )
            }
        }

        fun onEstadisticasBackClicked() {
            _uiState.update {
                it.copy(
                    showEstadisticasView = false,
                    showEstadisticasSeguridadView = false, // Limpiar Seguridad
                    showInformeSeguridadView = false,
                    // --- ¡ORDEN DE REINICIO! ---
                    // Reseteamos los filtros de esta pantalla a su estado inicial.
                    filtroMesEstadisticasGenerales = "ANUAL",
                    fechaInicioSeleccionada = null,
                    fechaFinSeleccionada = null
                )
            }
            // ¡ORDEN DE RECARGA! Vuelve a calcular el anual para la próxima vez que se entre.
            // Esto asegura que al volver a entrar, siempre se vea el resumen anual por defecto.
            val filtradasEstadisticas = filtrarIncidenciasPorAutoridad(todasLasIncidenciasMaestra)
            calcularEstadisticasGenerales(filtradasEstadisticas)
        }

        fun onShowInformeClicked() {
            _uiState.update {
                it.copy(
                    showInformeView = true,
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showDroneView = false,
                    showEstadisticasSeguridadView = false,
                    showInformeSeguridadView = false,
                    showDashboardSeguridadView = false
                )
            }
        }

    fun onInformeBackClicked() {
        val currentState = _uiState.value
        _uiState.update {
            it.copy(
                showInformeView = false,
                // --- ¡ORDEN DE REINICIO! ---
                filtroMesEstadisticasGenerales = "ANUAL",
                fechaInicioSeleccionada = null,
                fechaFinSeleccionada = null
            )
        }
        // ¡ORDEN DE RECARGA!
        val filtradasEstadisticas = filtrarIncidenciasPorAutoridad(todasLasIncidenciasMaestra)
        
        // Restauramos los filtros de la tabla principal si existen
        _uiState.update { it.copy(incidencias = filtradasEstadisticas) }
        
        calcularEstadisticasGenerales(filtradasEstadisticas)
    }






        // --- ¡¡¡NUEVAS FUNCIONES PARA EL OJO DE DIOS!!! ---
        fun onShowDroneViewClicked() {
            _uiState.update {
                it.copy(
                    showDroneView = true,
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showInformeView = false,
                    showCamerasView = false, // 🛡️ Blindaje
                    showEstadisticasSeguridadView = false,
                    showInformeSeguridadView = false,
                    showDashboardSeguridadView = false,
                    showGestionServiciosView = false,
                    showGestionPatrullasView = false
                )
            }
        }

        fun onShowCamerasViewClicked() {
            _uiState.update { it.copy(
                showCamerasView = true,
                selectedIncidencia = null,
                showMapView = false,
                showEstadisticasView = false,
                showInformeView = false,
                showDroneView = false,
                showEstadisticasSeguridadView = false,
                showInformeSeguridadView = false,
                showDashboardSeguridadView = false,
                showGestionServiciosView = false,
                showGestionPatrullasView = false
            ) }
        }

        fun onCamerasViewBackClicked() {
            _uiState.update { it.copy(showCamerasView = false) }
        }


        fun onDroneViewBackClicked() { // <-- ¡VICTORIA!
                _uiState.update { it.copy(showDroneView = false) }
            }

    // --- 🛡️ LLAVE DE FILTRADO MAESTRA (DOCTRINA UNIFICADA) ---
    
    fun cargarCatalogoDelitos() {
        viewModelScope.launch {
            try {
                val state = _uiState.value
                val rolUpper = (adminProfile.rol ?: "").uppercase().trim()
                val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SALVAVIDAS", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA")

                val esAdminGeneral = rolUpper == "GENERAL"
                val esAdminComunal = rolUpper == "COMUNAL" || rolUpper == "OPERADORA"
                val esAdminDao = rolUpper in rolesDAO || adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true

                // 1. Determinamos la soberanía territorial (GENERAL debe filtrar obligatoriamente)
                val comunaAFiltrar = if (esAdminGeneral) {
                    val nombreComunaSeleccionada = state.filtroComunaGestion ?: state.filtroComuna // 🛡️ SINCRO TOTAL
                    val comunaObj = state.comunas.find { it.comunaDisplayName == nombreComunaSeleccionada }
                    if (comunaObj != null) "comunas/${comunaObj.id}" else null
                } else {
                    adminProfile.comunaAsignadaRef
                }

                // 🛡️ REGLA DE ORO: Si es GENERAL y no hay comuna seleccionada, NO CARGAMOS NADA.
                if (esAdminGeneral && comunaAFiltrar == null) {
                    _uiState.update { it.copy(
                        delitosCatalog = emptyList(),
                        daoCatalog = emptyList()
                    ) }
                    console.log("Admin General: Filtro vacío, catálogo despejado.")
                    return@launch
                }

                // 2. Ejecutamos la carga según el rango de autoridad
                when {
                    esAdminGeneral || esAdminComunal -> {
                        val displayName = if (esAdminGeneral) {
                            state.filtroComuna
                        } else {
                            adminProfile.comunaAsignadaDisplayName
                        }

                        val delitos = webService.fetchAllDelitosCatalog(comunaAFiltrar, displayName)
                        val dao = webService.fetchAllDaoCatalog(comunaAFiltrar, displayName)
                        _uiState.update { it.copy(
                            delitosCatalog = delitos,
                            daoCatalog = dao
                        ) }
                        console.log("Catálogos cargados para $comunaAFiltrar ($displayName): Delitos(${delitos.size}), DAO(${dao.size})")
                    }
                    esAdminDao -> {
                        val daoFull = webService.fetchAllDaoCatalog(comunaAFiltrar, adminProfile.comunaAsignadaDisplayName)
                        val daoFiltrado = daoFull.filter {
                            val fam = it.familia.uppercase()
                            val n = it.nombre.uppercase()
                            
                            when(rolUpper) {
                                "DIRECCION_DAO" -> !n.contains("SEGURIDAD") && !n.contains("SALVAVIDAS")
                                "ASEO", "BASURA" -> fam == "ASEO" || fam == "BASURA"
                                "BACHE" -> fam == "BACHE"
                                "ILUMINACION" -> fam == "ILUMINACION"
                                "SEMAFORO" -> fam == "SEMAFORO"
                                "AUTO_ABANDONADO" -> fam == "AUTO_ABANDONADO"
                                "SALVAVIDAS" -> fam == "SALVAVIDAS"
                                "SOCIAL_ADMIN" -> fam == "SOCIAL"
                                "SEGURIDAD_ADULTO_MAYOR" -> fam == "ADULTO_MAYOR"
                                "EMERGENCIA_CARRETERA" -> fam == "EMERGENCIA"
                                else -> true
                            }
                        }
                        _uiState.update { it.copy(
                            delitosCatalog = emptyList(),
                            daoCatalog = daoFiltrado
                        ) }
                        console.log("Catálogo DAO filtrado cargado para $comunaAFiltrar ($rolUpper): ${daoFiltrado.size}")
                    }
                    else -> {
                        val delitos = webService.fetchAllDelitosCatalog(comunaAFiltrar, adminProfile.comunaAsignadaDisplayName)
                        _uiState.update { it.copy(
                            delitosCatalog = delitos,
                            daoCatalog = emptyList()
                        ) }
                        console.log("Catálogo Seguridad cargado para $comunaAFiltrar: ${delitos.size}")
                    }
                }
            } catch (e: Exception) {
                console.error("Falla al cargar catálogos: ${e.message}")
            }
        }
    }


    fun onCambiarEstadoDelito(delito: DelitoTipificado, actualEstado: Boolean) {
        viewModelScope.launch {
            val nuevoEstado = !actualEstado
            val esGeneral = (adminProfile.rol ?: "").uppercase() == "GENERAL"
            
            // 🛡️ DETERMINACIÓN DE SOBERANÍA (Corrección para Admin Comunal)
            val comunaRefFinal = if (esGeneral) {
                val found = _uiState.value.comunas.find { it.comunaDisplayName == _uiState.value.filtroComuna }
                if (found != null) "comunas/${found.id}" else null
            } else {
                adminProfile.comunaAsignadaRef
            }
            
            val comunaDisplayFinal = if (esGeneral) {
                _uiState.value.filtroComuna
            } else {
                adminProfile.comunaAsignadaDisplayName
            }

            // ⚡ ACTUALIZACIÓN OPTIMISTA: Delitos y Hallazgos
            _uiState.update { state ->
                val updatedDelitos = state.delitosCatalog.map {
                    if (it.nombre == delito.nombre) it.copy(estaActivo = nuevoEstado) else it
                }
                val updatedDao = state.daoCatalog.map {
                    if (it.nombre == delito.nombre) it.copy(estaActivo = nuevoEstado) else it
                }
                state.copy(delitosCatalog = updatedDelitos, daoCatalog = updatedDao)
            }

            try {
                val delitoActualizado = delito.copy(
                    estaActivo = nuevoEstado,
                    comunaAsignadaRef = delito.comunaAsignadaRef ?: comunaRefFinal,
                    comunaAsignadaDisplayName = delito.comunaAsignadaDisplayName ?: comunaDisplayFinal
                )

                webService.guardarOCrearDelito(delitoActualizado, nuevoEstado)
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Falla al guardar: ${e.message}") }
                cargarCatalogoDelitos() // Revertir con datos reales
            }
        }
    }
        fun actualizarTipificaciones(incidenciaId: String, nuevasTipificaciones: List<String>) {
            viewModelScope.launch {
                try {
                    // 1. Preparamos el mapa de actualización
                    val updates = mapOf("tipificacionesDelito" to nuevasTipificaciones.toTypedArray())
                    // 2. ¡FUEGO! Enviamos la orden al WebService
                    webService.actualizarIncidencia(incidenciaId, updates)

                    // 3. --- ¡LA MANIOBRA DE ANCLAJE! ---
                    // Llamamos a nuestro especialista en refresco para que la
                    // incidencia seleccionada se actualice SIN CERRARSE.
                    refrescarDatosYSeleccion(incidenciaId)
                    console.log("Radar: Tipificación exitosa y anclada para ID: $incidenciaId")
                } catch (e: Exception) {
                    _uiState.update { it.copy(error = "Error al tipificar: ${e.message}") }
                }
            }
        }

        fun actualizarAprehensionesWeb(incidenciaId: String, huboDetenidos: Boolean, cantidad: Int) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    val updates = mapOf(                        "huboDetenidos" to huboDetenidos,
                        "cantidadDetenidos" to cantidad
                    )
                    webService.actualizarIncidencia(incidenciaId, updates)

                    // --- ¡VICTORIA! Refrescamos para ver el recuadro rojo ---
                    refrescarDatosYSeleccion(incidenciaId)
                    _uiState.update { it.copy(isLoading = false) }
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al actualizar detenidos: ${e.message}") }
                }
            }
        }

        // --- ¡NUEVO COMANDO DE INTELIGENCIA OPERATIVA! ---
        fun actualizarProcedimientosWeb(
            incidenciaId: String,
            detenidos: Int,
            controles: Int,
            fiscalizaciones: Int
        ) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    val updates = mapOf(
                        "huboDetenidos" to (detenidos > 0),
                        "cantidadDetenidos" to detenidos,
                        "cantidadControlesIdentidad" to controles,
                        "cantidadFiscalizaciones" to fiscalizaciones
                    )
                    webService.actualizarIncidencia(incidenciaId, updates)

                    // Refrescamos para ver los nuevos números en pantalla
                    refrescarDatosYSeleccion(incidenciaId)
                    _uiState.update { it.copy(isLoading = false) }
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al actualizar procedimientos: ${e.message}") }
                }
            }
        }

        private suspend fun refrescarDatosYSeleccion(idIncidenciaSeleccionada: String) {
            // ¡YA NO LANZA SU PROPIA MISIÓN! AHORA OBEDECE Y ESPERA.
            try {
                val incidenciaActualizada = webService.fetchIncidenciaById(idIncidenciaSeleccionada)
                if (incidenciaActualizada != null) {
                    // Actualizamos la lista local de incidencias
                    val listaActual = _uiState.value.incidencias.toMutableList()
                    val index = listaActual.indexOfFirst { it.id == idIncidenciaSeleccionada }
                    if (index != -1) {
                        listaActual[index] = incidenciaActualizada
                    }
                    // Actualizamos la lista maestra también
                    val indexMaestra = todasLasIncidenciasMaestra.indexOfFirst { it.id == idIncidenciaSeleccionada }
                    if (indexMaestra != -1) {
                        val mutableMaestra = todasLasIncidenciasMaestra.toMutableList()
                        mutableMaestra[indexMaestra] = incidenciaActualizada
                        todasLasIncidenciasMaestra = mutableMaestra
                    }

                    // ¡LÓGICA DE DESPACHO INTELIGENTE!
                    if (_uiState.value.selectedIncidenciaDron != null) {
                        // Si estamos en la vista del dron, actualizamos el buzón del dron.
                        _uiState.update {
                            it.copy(
                                // Ya no maneja 'isLoading', lo hace el que llama.
                                incidencias = listaActual,
                                selectedIncidenciaDron = incidenciaActualizada // <-- ¡BUZÓN CORRECTO!
                            )
                        }
                    } else {
                        // Si no, usamos la lógica original para el administrador.
                        _uiState.update {
                            it.copy(
                                incidencias = listaActual,
                                selectedIncidencia = incidenciaActualizada // <-- Buzón del admin
                            )
                        }
                    }
                    // Recalculamos las estadísticas en segundo plano
                    val filtradasEstadisticas = filtrarIncidenciasPorAutoridad(todasLasIncidenciasMaestra)
                    calcularEstadisticasDelitos(filtradasEstadisticas)

                } else {
                    _uiState.update { it.copy(error = "No se pudo encontrar la incidencia después de actualizar.") }
                }
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error en refrescarDatosYSeleccion: ${e.message}") }
            }
        }
        // --- ¡EL INTERRUPTOR PARA LA NUEVA PANTALLA! ---
        fun onShowEstadisticasSeguridadClicked(forzarServiciosUrbanos: Boolean? = null) {
            val rolesEspecialistasNoSeguridad = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA", "SALVAVIDAS")
            val rolUpper = (adminProfile.rol ?: "").uppercase().trim()
            val esEspecialistaPorRol = rolUpper in rolesEspecialistasNoSeguridad || adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true
            
            val modoEfectivo = forzarServiciosUrbanos ?: esEspecialistaPorRol

            _uiState.update {
                it.copy(
                    modoServiciosUrbanos = modoEfectivo,
                    showEstadisticasSeguridadView = true,
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showInformeView = false,
                    showDroneView = false
                )
            }
            // --- 🛡️ SUTURA DE SOBERANÍA: CALCULAMOS SEGÚN EL MODO ELEGIDO ---
            val baseFiltrada = filtrarIncidenciasPorAutoridad(todasLasIncidenciasMaestra)
            calcularEstadisticasDelitos(baseFiltrada, modoEfectivo)
        }

        fun onEstadisticasSeguridadBackClicked() {
            _uiState.update {
                it.copy(
                    showEstadisticasSeguridadView = false,
                    filtroMesEstadisticas = "ANUAL",
                    fechaInicioSeleccionada = null,
                    fechaFinSeleccionada = null
                )
            }
            recalcularEstadisticasConFiltrosActuales()
        }


        // --- ¡INTERRUPTOR PARA EL NUEVO INFORME! ---
        fun onShowInformeSeguridadClicked() {
            _uiState.update {
                it.copy(
                    showInformeSeguridadView = true,
                    // Reseteamos las otras vistas
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showEstadisticasSeguridadView = false,
                    showInformeView = false,
                    showDroneView = false
                )
            }
        }

        fun onInformeSeguridadBackClicked() {
            _uiState.update {
                it.copy(
                    showInformeSeguridadView = false,
                    filtroMesEstadisticas = "ANUAL"
                )
            }
            // ¡ORDEN DE RECARGA! Vuelve a calcular el anual para la próxima vez.
            onFiltroMesEstadisticasChanged("ANUAL")
        }

    fun onFiltroRangoFechasChanged(fechaInicioUTC: Double, fechaFinUTC: Double) {
        viewModelScope.launch {
            _uiState.update {
                it.copy(
                    isLoading = true,
                    filtroMesEstadisticasGenerales = "ANUAL",
                    fechaInicioSeleccionada = fechaInicioUTC.toLong(),
                    fechaFinSeleccionada = fechaFinUTC.toLong()
                )
            }
            recalcularEstadisticasConFiltrosActuales()
        }
    }

        fun onFiltroRangoFechasDelitosChanged(fechaInicioUTC: Double, fechaFinUTC: Double) {
            viewModelScope.launch {
                _uiState.update {
                    it.copy(
                        isLoading = true,
                        filtroMesEstadisticas = null,
                        fechaInicioSeleccionada = fechaInicioUTC.toLong(),
                        fechaFinSeleccionada = fechaFinUTC.toLong()
                    )
                }
                recalcularEstadisticasConFiltrosActuales()
            }
        }

        // Dentro de la clase AdminPanelViewModel

        // --- ¡NUEVO COMANDO PARA ABRIR EL FORMULARIO DE INGRESO! ---
        fun onShowIngresoIncidenciaClicked() {
            _uiState.update {
                it.copy(
                    showIngresoIncidenciaView = true,
                    // Reseteamos las otras vistas para evitar conflictos
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showEstadisticasSeguridadView = false,
                    showInformeView = false,
                    showInformeSeguridadView = false,
                    showDroneView = false
                )
            }
        }


        // --- ¡COMANDO DE RETIRADA TÁCTICA! ---
        fun onIngresoIncidenciaBackClicked() {
            _uiState.update { it.copy(showIngresoIncidenciaView = false) }
        }

        fun onIngresarIncidenciaManual(datos: NuevaIncidenciaManual
        ) {        viewModelScope.launch {
            _uiState.update { it.copy(isLoadingGlobal = true, error = null) }
            try {
                // ¡Ahora la llamada es simple! El WebService hará el trabajo pesado.
                webService.crearIncidenciaManual(datos, adminProfile, _uiState.value.imagenSeleccionada)
                fetchAllData()
                _uiState.update { it.copy(isLoadingGlobal = false, showIngresoIncidenciaView = false) }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoadingGlobal = false, error = "Error al guardar la incidencia: ${e.message}") }
            }
            }
        }

        fun onGestionPatrullasBackClicked() {
            _uiState.update { it.copy(showGestionPatrullasView = false) }
        }

    fun onAsignarSector(solucionadorUid: String, nuevoSectorNombre: String, tipoIncidenciaAsignadaRef: String, tipoIncidenciaAsignadaDisplay: String) {
        if (nuevoSectorNombre.isBlank()) return
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                // 1. Enviamos la orden de CAMBIO DE SECTOR al trabajador
                webService.asignarSectorASolucionador(
                    solucionadorUid,
                    nuevoSectorNombre = nuevoSectorNombre,
                    nuevoSectorRef = tipoIncidenciaAsignadaRef,
                    nuevoSectorTipoDisplay = tipoIncidenciaAsignadaDisplay
                )

                // 2. Refrescamos usando el motor de gestión (aplica filtros de soberanía)
                cargarDatosDeGestion()
                console.log("Mando Central: Sector '$nuevoSectorNombre' asignado con éxito.")
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Falla al asignar: ${e.message}") }
            }
        }
    }

    // --- 🛡️ REPARACIÓN DEL PUNTO CIEGO AL ENTRAR ---
    fun onShowGestionPatrullasClicked(contextoRef: String = "", contextoDisplayName: String = "") {
        val state = _uiState.value
        val admin = adminProfile
        
        // 🛡️ IDENTIFICACIÓN TERRITORIAL: 
        // Si es General, usa la comuna filtrada en el dashboard. Si es Comunal, la suya.
        val (cRef, cName) = if (admin.rol == "GENERAL") {
            val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
            Pair(found?.id, found?.comunaDisplayName)
        } else {
            Pair(admin.comunaAsignadaRef, admin.comunaAsignadaDisplayName)
        }

        _uiState.update {
            it.copy(
                showGestionPatrullasView = true,
                patrullaContextoRef = contextoRef,
                patrullaContextoDisplayName = contextoDisplayName,
                patrullaComunaRef = cRef,
                patrullaComunaNombre = cName,
                selectedIncidencia = null,
                showMapView = false,
                showEstadisticasView = false,
                showInformeView = false,
                showDroneView = false,
                showIngresoIncidenciaView = false
            )
        }
        // ¡LA CLAVE! Llamamos a nuestro motor de carga con FILTRO DE SOBERANÍA
        cargarDatosDeGestion()
    }

        // --- ¡LA ORDEN PARA CAMBIAR EL ESTADO DE UNA PATRULLA! ---
        fun onCambiarEstadoSolucionador(solucionadorUid: String, estadoActual: Boolean) {
            // 1. ACTUALIZACIÓN OPTIMISTA (Instantáneo)
            _uiState.update { state ->
                val listaEditada = state.solucionadores.map { s ->
                    if (s.uidAuth == solucionadorUid) s.copy(estaActivo = !estadoActual) else s
                }
                state.copy(solucionadores = listaEditada)
            }

            viewModelScope.launch {
                try {
                    // 2. LLAMADA A RED (En segundo plano, sin bloqueo)
                    webService.cambiarEstadoSolucionador(solucionadorUid, !estadoActual)

                    // 3. RECARGA SEGURA (Usa el filtro de Soberanía DAO)
                    cargarDatosDeGestion()
                } catch (e: Exception) {
                    // Revertir si falla y mostrar error
                    cargarDatosDeGestion()
                    _uiState.update { it.copy(error = "Error: ${e.message}") }
                }
            }
        }

        // --- INTERRUPTORES PARA EL MODAL DE RECLUTAMIENTO ---
        fun onShowAgregarPatrullaModal() {
            _uiState.update { it.copy(showAgregarPatrullaModal = true) }
        }

        fun onHideAgregarPatrullaModal() {
            _uiState.update { it.copy(showAgregarPatrullaModal = false) }
        }



        // --- ¡LA ORDEN PARA DAR DE BAJA A UNA PATRULLA! ---
        fun onEliminarSolucionador(solucionadorUid: String) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    webService.eliminarSolucionador(solucionadorUid)
                    // Refrescamos usando el motor de gestión para mantener filtros de soberanía
                    cargarDatosDeGestion()
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al eliminar patrulla: ${e.message}") }
                }
            }
        }

        fun onActualizarNombreSolucionador(uid: String, nuevoNombre: String) {
            viewModelScope.launch {
                try {
                    webService.actualizarNombreSolucionador(uid, nuevoNombre)
                    cargarDatosDeGestion()
                } catch (e: Exception) {
                    console.error("Error al actualizar nombre de patrulla:", e)
                }
            }
        }
    // En AdminPanelViewModel.kt
        fun onAsignarIncidencia(
            incidenciaId: String,
            solucionadorUid: String,
            nombreSolucionador: String,
            nombreSector: String
        ) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    // 1. Enviamos la orden al WebService
                    webService.asignarIncidenciaASolucionador(incidenciaId, solucionadorUid, nombreSolucionador, nombreSector)

                    // 2. --- ¡LA MANIOBRA DE ANCLAJE! ---
                    // En lugar de cerrar el detalle, refrescamos los datos para ver
                    // el nombre de la patrulla y el sector en verde.
                    refrescarDatosYSeleccion(incidenciaId)

                    // 3. Recargamos el resto de los datos en segundo plano
                    fetchAllData()

                    _uiState.update { it.copy(isLoading = false) }
                    console.log("Radar: Asignación exitosa y detalle anclado para ID: $incidenciaId")

                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al asignar incidencia: ${e.message}") }
                }
            }
        }


        // --- ¡EL GATILLO PARA EL NUEVO DASHBOARD! ---
        fun onShowDashboardSeguridadClicked() {
            _uiState.update {
                it.copy(
                    // 1. Levantamos la bandera de nuestra nueva pantalla.
                    showDashboardSeguridadView = true,
                    // 2. Reseteamos TODAS las otras vistas para evitar conflictos.
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showInformeView = false,
                    showDroneView = false,
                    showGestionPatrullasView = false,
                    showInformeSeguridadView = false,
                    showIngresoIncidenciaView = false
                )
            }
        }


        fun onDashboardSeguridadBackClicked() {
            _uiState.update { it.copy(showDashboardSeguridadView = false) }
        }

        // --- ¡MÓDULO DE COMUNICACIÓN MASIVA (CABALLO DE TROYA)! ---
        fun onShowNoticiasClicked() {
            _uiState.update {
                it.copy(
                    showNoticiasView = true,
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showInformeView = false,
                    showDroneView = false,
                    showGestionPatrullasView = false,
                    showDashboardSeguridadView = false,
                    showGestionDelitosView = false,
                    showGestionServiciosView = false,
                    showIngresoIncidenciaView = false
                )
            }
            cargarHistorialNoticias()
            cargarSectoresSegmentacion()
        }

        fun onNoticiasBackClicked() {
            _uiState.update { it.copy(showNoticiasView = false) }
        }

        private fun cargarSectoresSegmentacion() {
            viewModelScope.launch {
                try {
                    val admin = _uiState.value.rolAdmin
                    val comunaRef = admin?.comunaAsignadaRef
                    if (comunaRef != null) {
                        val lista = webService.fetchSectoresByComuna(comunaRef)
                        _uiState.update { it.copy(sectoresComuna = lista) }
                    }
                } catch (e: Exception) {
                    console.error("Error al cargar sectores: ${e.message}")
                }
            }
        }

        private fun cargarHistorialNoticias() {
            viewModelScope.launch {
                try {
                    val admin = _uiState.value.rolAdmin
                    val esGeneral = admin?.rol == "GENERAL"
                    
                    if (esGeneral) {
                        val lista = webService.fetchNoticias("TODAS")
                        _uiState.update { it.copy(historialNoticias = lista) }
                    } else {
                        // 🛡️ DOCTRINA PURA: Usamos el ID limpio (sin prefijos) para la consulta
                        val refOriginal = admin?.comunaAsignadaRef ?: ""
                        val miIdLimpio = refOriginal.split("/").last()
                        
                        console.log("Radar: Consultando historial PURO para: $miIdLimpio")
                        
                        val lista = webService.fetchNoticias(miIdLimpio)
                        _uiState.update { it.copy(historialNoticias = lista.sortedByDescending { n -> n.fechaCreacion }) }
                        console.log("Radar: Historial cargado (${lista.size} comunicados)")
                    }
                } catch (e: Exception) {
                    console.error("Error al cargar noticias: ${e.message}")
                }
            }
        }

        fun enviarNoticiaMasiva(
            titulo: String,
            contenido: String,
            fotoArchivo: org.w3c.files.File? = null, // --- ¡LA CLAVE! El archivo real ---
            categoria: String = "GENERAL",
            sectorRef: String? = null,
            sectorNombre: String? = null,
            edadMin: Int? = null,
            edadMax: Int? = null,
            overrideComunaRef: String? = null,
            overrideComunaNombre: String? = null
        ) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoadingGlobal = true) }
                try {
                    // 1. SI HAY ARCHIVO, LO SUBIMOS PRIMERO
                    var finalUrl: String? = null
                    if (fotoArchivo != null) {
                        console.log("Mando Central: Subiendo imagen adjunta...")
                        finalUrl = webService.uploadNoticiaPhoto(fotoArchivo)
                    }

                    val admin = _uiState.value.rolAdmin
                    val esGeneral = admin?.rol == "GENERAL"
                    
                    val finalComunaRef = overrideComunaRef ?: (if (esGeneral) "TODAS" else admin?.comunaAsignadaRef ?: "GENERAL")
                    val finalComunaNombre = overrideComunaNombre ?: (if (esGeneral) "Global" else admin?.comunaAsignadaDisplayName ?: "Global")

                    // ... (validaciones de cuota sin cambios) ...

                    // 2. PUBLICAMOS CON LA URL RECIÉN GENERADA
                    webService.publicarNoticiaMasiva(
                        titulo = titulo,
                        contenido = contenido,
                        imagenUrl = finalUrl, // Usamos la URL del Storage
                        categoria = categoria,
                        comunaRef = finalComunaRef,
                        comunaNombre = finalComunaNombre,
                        autor = admin?.nombre ?: "Admin",
                        sectorRef = sectorRef,
                        sectorDisplayName = sectorNombre,
                        edadMinima = edadMin,
                        edadMaxima = edadMax
                    )
                    
                    // --- 🔄 RECARGA DE HISTORIAL (ESTRATEGIA SOBERANA) ---
                    // El Admin General siempre recarga "TODAS" para ver el impacto global de sus mensajes
                    val histRef = if (esGeneral) "TODAS" else finalComunaRef
                    val lista = webService.fetchNoticias(histRef)
                    
                    _uiState.update { it.copy(historialNoticias = lista, isLoadingGlobal = false) }
                    
                    window.alert("✅ ¡Comunicado enviado con éxito a $finalComunaNombre!")
                    
                } catch (e: Exception) {
                    console.error("Falla en envío masivo: ${e.message}")
                    _uiState.update { it.copy(isLoadingGlobal = false, error = e.message) }
                    val errorMsg = e.message ?: "Error desconocido"
                    if (!errorMsg.contains("LÍMITE ALCANZADO") && !errorMsg.contains("SERVICIO DESHABILITADO")) {
                        window.alert("❌ Falla al enviar comunicado: $errorMsg")
                    }
                }
            }
        }

        fun onComunaNoticiaChanged(comunaRef: String?) {
            viewModelScope.launch {
                try {
                    // 1. Cargamos sectores para segmentación local
                    val finalComunaRef = if (comunaRef == "TODAS" || comunaRef.isNullOrBlank()) null else comunaRef
                    if (finalComunaRef != null) {
                        val listaSectores = webService.fetchSectoresByComuna(finalComunaRef)
                        _uiState.update { it.copy(sectoresComuna = listaSectores) }
                    } else {
                        _uiState.update { it.copy(sectoresComuna = emptyList()) }
                    }

                    // 2. Cargamos el historial de esa comuna específica o Global
                    val histRef = if (comunaRef.isNullOrBlank()) "TODAS" else comunaRef
                    val listaNoticias = webService.fetchNoticias(histRef)
                    _uiState.update { it.copy(historialNoticias = listaNoticias) }
                    
                    console.log("Radar: Filtro de noticias cambiado a $histRef. Sectores cargados: ${_uiState.value.sectoresComuna.size}")
                } catch (e: Exception) {
                    console.error("Error al cambiar comuna en noticias: ${e.message}")
                }
            }
        }

        fun onEliminarNoticia(id: String) {
            if (window.confirm("¿Está seguro de eliminar este comunicado?")) {
                viewModelScope.launch {
                    try {
                        webService.eliminarNoticia(id)
                        cargarHistorialNoticias() // Refrescamos el listado
                    } catch (e: Exception) {
                        console.error("Error al eliminar noticia: ${e.message}")
                    }
                }
            }
        }

        // --- 🏛️ COMANDOS DE GESTIÓN DE GABINETE ---
        fun onShowGestionGabineteClicked(comunaRef: String? = null, comunaNombre: String? = null) {
            _uiState.update { 
                it.copy(
                    showGestionGabineteView = true,
                    selectedComunaGabineteRef = comunaRef ?: it.rolAdmin?.comunaAsignadaRef,
                    selectedComunaGabineteNombre = comunaNombre ?: it.rolAdmin?.comunaAsignadaDisplayName,
                    selectedIncidencia = null,
                    showMapView = false,
                    showEstadisticasView = false,
                    showInformeView = false,
                    showDroneView = false,
                    showGestionPatrullasView = false,
                    showDashboardSeguridadView = false,
                    showGestionDelitosView = false,
                    showGestionComunasView = false,
                    showGestionServiciosView = false,
                    showIngresoIncidenciaView = false
                ) 
            }
            cargarGabinete()
        }

        fun onGestionGabineteBackClicked() {
            _uiState.update { it.copy(showGestionGabineteView = false) }
        }

        fun onAgregarFuncionarioClicked() {
            val state = _uiState.value
            val comName = state.selectedComunaGabineteNombre ?: state.rolAdmin?.comunaAsignadaDisplayName ?: "Sin Nombre"
            val comRef = state.selectedComunaGabineteRef ?: state.rolAdmin?.comunaAsignadaRef ?: ""
            
            if (comRef.isBlank()) {
                window.alert("Error: No se identificó la comuna objetivo.")
                return
            }

            val domain = comName.lowercase().replace(" ", "")
            val prefijo = window.prompt("Ingrese prefijo para el nuevo email (Ej: operadora_noche, bache_2):")
            if (prefijo.isNullOrBlank()) return

            val emailFinal = "$prefijo@$domain.cl"
            
            val rolesDisponibles = listOf("COMUNAL", "DIRECCION_DAO", "SEGURIDAD_ADMIN", "SOCIAL_ADMIN", "OPERADORA", "OPERADOR_DRON", "OPERADOR_CAMARAS", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SALVAVIDAS")
            val rolElegido = window.prompt("Elija el ROL del funcionario:\n${rolesDisponibles.joinToString(", ")}", "OPERADORA")
            if (rolElegido == null || !rolesDisponibles.contains(rolElegido.uppercase())) {
                window.alert("Rol no válido.")
                return
            }

            val nombreCargo = window.prompt("Ingrese DESCRIPCIÓN del cargo (Ej: Operadora Turno Noche):", "Nuevo Funcionario")
            if (nombreCargo == null) return

            viewModelScope.launch {
                try {
                    _uiState.update { it.copy(isLoading = true) }
                    
                    webService.crearPerfilAdminshell(
                        nombre = nombreCargo,
                        email = emailFinal,
                        rol = rolElegido.uppercase(),
                        comunaRef = comRef,
                        comunaName = comName
                    )
                    
                    cargarGabinete()
                    _uiState.update { it.copy(isLoading = false) }
                    window.alert("✅ Perfil creado con ID Aleatorio. Ahora debe pulsar 'ACTIVAR' para generar el acceso real.")
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = e.message) }
                }
            }
        }

        fun onActivarAccesoClicked(admin: Administrador) {
            val email = admin.email ?: return
            
            // --- 🛡️ PROTOCOLO DE IDENTIDAD CIVIL ---
            val nombreReal = window.prompt("Ingrese NOMBRE COMPLETO del funcionario responsable:", admin.nombre ?: "")
            if (nombreReal.isNullOrBlank()) return 
            
            val rutReal = window.prompt("Ingrese RUT del funcionario (ej: 12.345.678-K):", "")
            if (rutReal.isNullOrBlank()) return 

            val identificacionFinal = "$nombreReal (RUT: $rutReal)"
            
            if (window.confirm("¿Confirmar activación de acceso oficial?\n\nFuncionario: $identificacionFinal\nEmail: $email\nClave inicial: 111111")) {
                viewModelScope.launch {
                    try {
                        _uiState.update { it.copy(isLoading = true) }
                        
                        // 🛡️ SINCRO DE ADN: Usamos el UID Real (ID del documento) que viene de Firebase
                        val docIdReal = admin.uidAuth
                        
                        // 1. Limpiamos el nombre si ya trae RUT (evita duplicados)
                        val nombreLimpio = (nombreReal.split("(").first()).trim()
                        val identificacionFinal = "$nombreLimpio (RUT: $rutReal)"

                        // 2. Guardamos la identidad real en Firestore usando su ID REAL
                        webService.actualizarNombreAdmin(docIdReal, identificacionFinal)
                        
                        // 3. Activamos en Firebase Auth vía Canal Secundario
                        val result = webService.activarAccesoFuncionario(email, docIdReal)
                        
                        if (result == "ALREADY_EXISTS") {
                            window.alert("ℹ️ Vínculo de Seguridad: El usuario ya existía en el sistema de llaves.\n\nSe ha sincronizado con $identificacionFinal.")
                        } else if (result == "AUTH_ERROR_EXISTING_USER") {
                            window.alert("❌ Conflicto de Claves: El email está en uso con una clave privada distinta a '111111'.")
                        } else {
                            window.alert("✅ ACCESO ACTIVADO EXITOSAMENTE.\n\nFuncionario: $identificacionFinal\nEmail: $email\nClave: 111111")
                        }
                    } catch (e: Exception) {
                        console.error("Falla crítica en activación:", e)
                        window.alert("Falla en activación: ${e.message}")
                    } finally {
                        // 🛡️ REFUERZO DE REACTIVIDAD: Limpiamos carga y forzamos recarga del gabinete
                        _uiState.update { it.copy(isLoading = false) }
                        kotlinx.coroutines.delay(500) // Un pequeño respiro para Firestore
                        cargarGabinete()
                    }
                }
            }
        }

        fun onCambiarEstadoAdmin(admin: Administrador, nuevoEstado: Boolean) {
            viewModelScope.launch {
                try {
                    // 🛡️ SINCRO DE ADN: Usamos el ID Real del documento
                    webService.actualizarEstadoAdmin(admin.uidAuth, nuevoEstado)
                    cargarGabinete()
                } catch (e: Exception) {
                    console.error("Error al cambiar estado admin:", e)
                }
            }
        }

        fun onActualizarNombreAdmin(admin: Administrador, nuevoNombre: String) {
            viewModelScope.launch {
                try {
                    // 🛡️ SINCRO DE ADN: Usamos el ID Real del documento
                    webService.actualizarNombreAdmin(admin.uidAuth, nuevoNombre)
                    cargarGabinete()
                } catch (e: Exception) {
                    console.error("Error al actualizar nombre admin:", e)
                }
            }
        }

        fun onResetClaveClicked(admin: Administrador) {
            val email = admin.email ?: return
            if (window.confirm("¿Desea resetear la clave de $email a la clave estándar '111111'?")) {
                viewModelScope.launch {
                    try {
                        // Implementaremos el reset vía WebService en el siguiente paso
                        window.alert("⚠️ Función en desarrollo: Por ahora, el Admin General debe resetearla en la consola. Pronto estará automatizada.")
                    } catch (e: Exception) {
                        console.error("Error en reset:", e)
                    }
                }
            }
        }

        fun onEliminarAdminClicked(admin: Administrador) {
            val email = admin.email ?: return
            if (window.confirm("🚨 ¿ESTÁ SEGURO DE ELIMINAR A ESTE FUNCIONARIO?\n\nPerderá el acceso de inmediato.")) {
                viewModelScope.launch {
                    try {
                        _uiState.update { it.copy(isLoading = true) }
                        
                        // 🛡️ SINCRO DE ADN: Usamos el ID Real del documento
                        webService.eliminarAdmin(admin.uidAuth)

                        cargarGabinete()
                        _uiState.update { it.copy(isLoading = false) }
                        window.alert("✅ Funcionario eliminado del sistema.")
                    } catch (e: Exception) {
                        _uiState.update { it.copy(isLoading = false) }
                        window.alert("Error al eliminar: ${e.message}")
                    }
                }
            }
        }

        private fun onLogout() {
             viewModelScope.launch {
                 webService.signOut()
                 window.location.reload()
             }
        }

        private fun cargarGabinete() {
            viewModelScope.launch {
                try {
                    // Forzamos limpieza del estado anterior para asegurar refresco visual
                    _uiState.update { it.copy(isLoading = true, gabineteAdmins = emptyList()) }
                    
                    val targetRef = _uiState.value.selectedComunaGabineteRef
                    val lista = webService.fetchAllAdmins(targetRef)
                    
                    _uiState.update { it.copy(gabineteAdmins = lista, isLoading = false) }
                    console.log("Radar: Gabinete sincronizado (${lista.size} perfiles oficiales)")
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = e.message) }
                }
            }
        }

        fun actualizarCampoBooleano(incidenciaId: String, campo: String, nuevoValor: Boolean) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) } // 1. Mostramos que estamos trabajando
                try {
                    // 2. ¡FUEGO! Actualizamos la base de datos
                    webService.actualizarIncidencia(incidenciaId, mapOf(campo to nuevoValor))

                    // 3. ¡CONFIRMACIÓN TÁCTICA! Refrescamos los datos locales
                    refrescarDatosYSeleccion(incidenciaId)

                    // 5. ¡VICTORIA! Dejamos de mostrar el indicador de carga.
                    _uiState.update { it.copy(isLoading = false) }

                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Error al actualizar '$campo': ${e.message}") }
                }
            }
        }



    //////////////////////////////////////////////
        fun onKpiFiltroSectorChanged(sector: String) {
            val sectorReal = if (sector == "TODOS") "TODOS" else sector
            _uiState.update { it.copy(kpiFiltroSector = sectorReal) }
        }

        fun onKpiDateChanged(type: String, value: String) {
            if (value.isBlank()) return
            // --- ¡LA SINTAXIS VICTORIOSA! ---
            // Usamos ${value} para delimitar la variable y .toLong() en el lugar correcto.
            val date = Date("${value}T12:00:00Z")
            val timestamp = date.getTime().toLong() // La conversión a Long se hace aquí
            when (type) {
                "inicio_actual" -> _uiState.update { it.copy(kpiFechaInicioActual = timestamp) }
                "fin_actual" -> _uiState.update { it.copy(kpiFechaFinActual = timestamp) }
            }
        }


        // --- ¡CONTROLADORES DE LA MÁQUINA DEL TIEMPO! (VERSIÓN ÚNICA Y CORRECTA) ---
        fun onKpiPeriodoChanged(periodoId: String) {
            _uiState.update { it.copy(kpiPeriodoSeleccionado = periodoId) }
        }

        // --- ¡LA FUNCIÓN POTENCIADA QUE AHORA ACEPTA DOS PARÁMETROS! ---
        fun onKpiAnioChanged(tipoAnio: String, anio: Int) {
            when (tipoAnio) {
                "principal" -> _uiState.update { it.copy(kpiAnioPrincipal = anio) }
                "comparacion" -> _uiState.update { it.copy(kpiAnioComparacion = anio) }
            }
        }

        // Eliminamos onKpiDateChanged y onKpiMesChanged que ya no se usan con la nueva consola.


        fun onKpiMesChanged(type: String, mes: Int) {
            when (type) {
                "inicio_comp" -> _uiState.update { it.copy(kpiMesInicioComparacion = mes) }
                "fin_comp" -> _uiState.update { it.copy(kpiMesFinComparacion = mes) }
            }
        }

        // --- ¡EL GATILLO DEL "SÚPER-MOTOR"! ---

        fun onCalcularKpisClicked() {
            val currentState = _uiState.value
            val anioPrincipal = currentState.kpiAnioPrincipal
            val anioComparacion = currentState.kpiAnioComparacion
            val periodoSeleccionado = currentState.kpiPeriodosDisponibles.find { it.id == currentState.kpiPeriodoSeleccionado } ?: return

            // ¡LLAMAMOS A LA VERSIÓN CORREGIDA DE CALCULAR KPIS!
            calcularKPIs(
                anioPrincipal = anioPrincipal,
                anioComparacion = anioComparacion,
                meses = periodoSeleccionado.meses
            )
        }

        // --- ¡LA UNIDAD LOGÍSTICA PERDIDA, AHORA REDESPLEGADA COMO PRIVADA! ---
        private fun despacharRepositorio(anio: Int): HistoricoRepository? {
            return when (anio) {
                2025 -> EstadisticasOficiales2025Repository
                2024 -> EstadisticasOficiales2024Repository
                2023 -> EstadisticasOficiales2023Repository
                2022 -> EstadisticasOficiales2022Repository
                2021 -> EstadisticasOficiales2021Repository
                else -> null
            }
        }

    fun calcularEstadisticasDelitos(incidenciasParaCalcular: List<Incidencia>, forzarServiciosUrbanos: Boolean? = null) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }

            // 🛡️ DOCTRINA DE PURIFICACIÓN: Segregamos los catálogos para evitar mezclas indeseadas
            fun String.normalizar(): String = this.uppercase().trim()
                .replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U")

            val nombresDelitosDao = TipificacionesDao.listaMaestraDao.map { it.nombre.normalizar() }
            val familiasDaoNombres = TipificacionesDao.obtenerTodasLasFamilias()

            // 🛡️ DOCTRINA "OJO DE ÁGUILA": Identificamos el contexto de Servicios Urbanos (DAO)
            val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SOCIAL_ADMIN", "SEGURIDAD_ADULTO_MAYOR", "EMERGENCIA_CARRETERA", "SALVAVIDAS")
            val esPorRolDao = adminProfile.rol in rolesDAO ||
                               adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true ||
                               (adminProfile.rol ?: "").contains("DAO", ignoreCase = true)
            
            // Si forzarServiciosUrbanos es null, usamos la lógica de rol. Si no, respetamos el parámetro
            val modoEfectivoServiciosUrbanos = forzarServiciosUrbanos ?: esPorRolDao

            // 1. FILTRAR INCIDENCIAS RELEVANTES (Purificación)
            val incidenciasRelevantes = incidenciasParaCalcular.filter { inc ->
                val disp = (inc.tipoIncidenciaDisplayName ?: "").normalizar()
                if (disp.contains("SERVICIO MUNICIPAL")) return@filter false

                val esSeguridadPura = disp == "SEGURIDAD CIUDADANA"
                if (modoEfectivoServiciosUrbanos) !esSeguridadPura else esSeguridadPura
            }.distinctBy { it.id } // Garantizamos unicidad absoluta

            // 🛡️ MOTOR DE CATEGORIZACIÓN (VUELTA AL TIPO DE INCIDENCIA REAL)
            fun resolverCategoriaVisual(inc: Incidencia): String {
                val tRaw = (inc.tipoIncidenciaDisplayName ?: "").trim()
                val tNorm = tRaw.normalizar()
                
                // 1. Barrido de keywords para normalizar familias (Soberanía de Datos Waldo)
                val searchSpace = (listOf(tNorm) + inc.tipificacionesDelito.map { it.normalizar() }).joinToString(" ")
                
                if (searchSpace.contains("BASURA") || searchSpace.contains("ASEO") || searchSpace.contains("BARRIDO") || searchSpace.contains("RECOLECCION") || searchSpace.contains("RESIDUO") || searchSpace.contains("ESCOMBRO")) return "Basura"
                if (searchSpace.contains("BACHE") || searchSpace.contains("HOYO") || searchSpace.contains("PAVIMENTO") || searchSpace.contains("EVENTO") || searchSpace.contains("SOCAVON")) return "Baches"
                if (searchSpace.contains("ILUMINA") || searchSpace.contains("LUMINARIA") || searchSpace.contains("LUZ") || searchSpace.contains("POSTE") || searchSpace.contains("FOCO")) return "Iluminación"
                if (searchSpace.contains("SEMAFORO")) return "Semáforos"
                if (searchSpace.contains("AUTO") || searchSpace.contains("VEHICULO") || searchSpace.contains("ESTACIONADO") || searchSpace.contains("ABANDONADO")) return "Autos Abandonados"
                if (searchSpace.contains("SALVAVI") || searchSpace.contains("PLAYA") || searchSpace.contains("AHOG") || searchSpace.contains("MARITIMO")) return "Salvavidas"
                if (searchSpace.contains("SOCIAL") || searchSpace.contains("DISCAPACIDAD") || searchSpace.contains("PUEBLOS") || searchSpace.contains("AYUDA")) return "Asistencia Social"
                if (searchSpace.contains("ADULTO") || searchSpace.contains("MAYOR") || searchSpace.contains("EDAD")) return "Adulto Mayor"
                if (searchSpace.contains("EMERGENCIA") || searchSpace.contains("SOS") || searchSpace.contains("CARRETERA")) return "SOS Carretera"

                if (tRaw.isBlank() || tNorm == "GENERAL") return "Otros"
                return tRaw.lowercase().split(" ").filter { it.isNotBlank() }.joinToString(" ") { it.replaceFirstChar { it.uppercase() } }
            }

            // 2. CÁLCULOS
            fun calcularDesglose(lista: List<Incidencia>): DesgloseEstadistico {
                val total = lista.size
                val sol = lista.count { it.estado == "SOLUCIONADO" }
                val rech = lista.count { it.estado == "RECHAZADO" }
                val verif = lista.count { it.estado == "VERIFICADO" }
                return DesgloseEstadistico(total, sol, total - sol - rech - verif, rech, verif)
            }

            val desglosePorGrupo = incidenciasRelevantes
                .groupBy { inc ->
                    if (modoEfectivoServiciosUrbanos) {
                        resolverCategoriaVisual(inc)
                    } else {
                        val tip = inc.tipificacionesDelito.firstOrNull() ?: inc.tipoIncidenciaDisplayName ?: "Sin Grupo"
                        val delitoCead = TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(tip)
                        val delitoDao = TipificacionesDao.obtenerDelitoPorNombre(tip)
                        delitoCead?.grupo ?: delitoDao?.grupo ?: "Sin Grupo"
                    }
                }
                .mapValues { calcularDesglose(it.value) }

            val desglosePorDelito = incidenciasRelevantes.flatMap { inc ->
                if (modoEfectivoServiciosUrbanos) {
                    // 🛡️ DOCTRINA DE DETALLE PURO: Solo mostramos tipificaciones que NO sean el nombre de la familia.
                    val familiaNorm = resolverCategoriaVisual(inc).normalizar()
                    val blackList = setOf("BASURA", "BACHE", "BACHES", "ILUMINACION", "ILUMINACIÓN", "SEMAFORO", "SEMAFOROS", "AUTO ABANDONADO", "AUTOS ABANDONADOS", "SALVAVIDAS", "GENERAL", "OTROS", "ASEO", "BARRIDO", "RECOLECCION")
                    
                    inc.tipificacionesDelito
                        .filter { it.isNotBlank() }
                        .map { it.normalizar() }
                        .filter { tip -> 
                            tip != familiaNorm && tip !in blackList && tip.length > 3 
                        }
                        .map { it to inc }
                } else {
                    val tips = inc.tipificacionesDelito.filter { it.isNotBlank() }
                    if (tips.isEmpty()) listOf((inc.tipoIncidenciaDisplayName ?: "General").normalizar() to inc)
                    else tips.map { it.normalizar() to inc }
                }
            }.groupBy { it.first }.mapValues { entry ->
                calcularDesglose(entry.value.map { it.second }.distinctBy { it.id })
            }.mapKeys { (key, _) ->
                // Aplicamos Title Case para que en la tabla no aparezca TODO EN MAYÚSCULAS
                key.lowercase().split(" ").filter { it.isNotBlank() }.joinToString(" ") { it.replaceFirstChar { c -> c.uppercase() } }
            }

            val estadisticasFinales = EstadisticasDelitos(
                resumenGeneral = calcularDesglose(incidenciasRelevantes),
                desglosePorGrupo = desglosePorGrupo,
                desglosePorDelito = desglosePorDelito
            )

            _uiState.update { it.copy(estadisticasDelitos = estadisticasFinales, isLoading = false) }
        }
    }

        // --- ¡MOTOR DE KPIS RECONSTRUIDO BAJO LA NUEVA DOCTRINA DE UNIFICACIÓN! ---
        fun calcularKPIs(
            anioPrincipal: Int,
            anioComparacion: Int,
            meses: IntRange
        ) {
            viewModelScope.launch {            _uiState.update { it.copy(isLoading = true, dashboardKpis = null) }

                // --- ¡LA FUNCIÓN INTERNA, AHORA CON EL NUEVO PARÁMETRO! ---
                val obtenerConteo = { anio: Int, delitoCEAD: String, rangoMeses: IntRange, soloConDetenidos: Boolean ->
                    if (anio >= 2026) {
                        // Para datos en vivo, contamos sobre la lista maestra
                        todasLasIncidenciasMaestra.filter { inc ->
                            val fecha = inc.fechaCreacion?.let { ts -> Date(ts) } ?: return@filter false
                            fecha.getUTCFullYear() == anio && (fecha.getUTCMonth() + 1) in rangoMeses
                        }.count { incidencia ->
                            // --- ¡LA LÓGICA REFORZADA E INTELIGENTE! ---
                            val rolesDao = listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "DIRECCION_DAO")
                            val esDao = adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true || 
                                        (adminProfile.rol ?: "").contains("DAO", ignoreCase = true) ||
                                        adminProfile.rol in rolesDao
                            val delitoMatch = incidencia.tipificacionesDelito.any { it.equals(delitoCEAD, ignoreCase = true) ||
                                    if (esDao) {
                                        TipificacionesDao.obtenerDelitoPorNombre(it)?.familia == delitoCEAD ||
                                        TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(it)?.familia == delitoCEAD
                                    } else {
                                        TipificacionesRepositoryCEAD.obtenerDelitoPorNombre(it)?.familia == delitoCEAD ||
                                        TipificacionesDao.obtenerDelitoPorNombre(it)?.familia == delitoCEAD
                                    }
                            }
                            if (soloConDetenidos) {
                                delitoMatch && incidencia.huboDetenidos
                            } else {
                                delitoMatch
                            }
                        }.toDouble()
                    } else {
                        // Si el año es histórico y se piden detenidos, devolvemos 0 porque no tenemos ese dato.
                        if (soloConDetenidos) 0.0 else {
                            val repo = despacharRepositorio(anio)
                            if (repo != null) repo.obtenerConteoHistorico(delitoCEAD, rangoMeses).toDouble() else 0.0
                        }
                    }
                }

            val calcularKpiDeVariacion = { delitoBuscado: String ->
                // Esta lógica NO CAMBIA. Sigue comparando totales.
                val countActual = obtenerConteo(anioPrincipal, delitoBuscado, meses, false)
                val countAnterior = obtenerConteo(anioComparacion, delitoBuscado, meses, false)

                val variacion: Double = if (countAnterior > 0.0) {
                    ((countActual / countAnterior) - 1.0) * 100.0
                } else if (countActual > 0.0) {
                    100.0
                } else {
                    0.0
                }
                KpiValue(valorActual = countActual, valorAnterior = countAnterior, variacion = variacion)
            }

            // --- ¡NUEVA LÍNEA DE ATAQUE, AHORA CON LA LLAMADA CORRECTA! ---
            val rolUpper = (adminProfile.rol ?: "").uppercase().trim()
            val esDao = (adminProfile.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true || 
                        rolUpper.contains("DAO") ||
                        rolUpper in listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")) && rolUpper != "GENERAL"

            val vifConDetenidosCount = if (!esDao) obtenerConteo(anioPrincipal, "Violencia intrafamiliar", meses, true) else 0.0

            // La variable 'kpiVifCalculado' se calcula dentro de la llamada al constructor.

            val kpisFinales = DashboardKpis(
                kpiDrogas = if (esDao) calcularKpiDeVariacion("BASURA") else calcularKpiDeVariacion("Tráfico de sustancias"),
                kpiRobos = if (esDao) calcularKpiDeVariacion("BACHE") else calcularKpiDeVariacion("Robos con violencia o intimidación"),
                kpiVif = if (esDao) calcularKpiDeVariacion("ILUMINACION") else calcularKpiDeVariacion("Violencia intrafamiliar"),
                kpiAmenazas = if (esDao) calcularKpiDeVariacion("SEMAFORO") else calcularKpiDeVariacion("Amenazas"),
                kpiEbriedad = if (esDao) calcularKpiDeVariacion("AUTO_ABANDONADO") else calcularKpiDeVariacion("Consumo de alcohol en la vía pública"),
                kpiVifDetenidos = vifConDetenidosCount
            )

            _uiState.update { it.copy(isLoading = false, dashboardKpis = kpisFinales) }
        }
    }


    @NoLiveLiterals
    private fun calcularKpisHistoricos() {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoadingHistoricos = true) }

            // --- ¡TU NUEVA DOCTRINA DE NOMENCLATURA DUAL! ---
            // Un par: (Nombre para mostrar en la UI, Nombre del dato para calcular)
            val kpisClave = listOf(
                "KPI 1: DROGAS Y SUSTANCIAS" to "Tráfico de sustancias",
                "KPI 2: ROBOS (VIOLENCIA O INTIMIDACIÓN)" to "Robos con violencia o intimidación",
                "KPI 3: VIOLENCIA INTRAFAMILIAR" to "Violencia intrafamiliar",
                "KPI 4: AMENAZAS Y COACCIÓN" to "Amenazas",
                "KPI 5: CONSUMO ALCOHOL VÍA PÚBLICA" to "Consumo de alcohol en la vía pública"
            )
            val aniosHistoricos = 2021..2024

            // Ahora iteramos sobre el par (destructurado)
            val kpisDetalladosCalculados = kpisClave.map { (nombreParaMostrar, nombreParaCalcular) ->
                val historialAnual = aniosHistoricos.map { anioActual ->
                    val anioSiguiente = anioActual + 1
                    
                    val obtenerConteoSumado = { anio: Int, delitoOFamilia: String ->
                        val repo = despacharRepositorio(anio)
                        if (repo != null) repo.obtenerConteoHistorico(delitoOFamilia, 1..12).toDouble() else 0.0
                    }

                    // ¡VICTORIA! Usamos el nombre correcto para el cálculo
                    val conteoActual = obtenerConteoSumado(anioActual, nombreParaCalcular)
                    val conteoSiguiente = obtenerConteoSumado(anioSiguiente, nombreParaCalcular)

                    val variacion: Double = if (conteoActual > 0.0) {
                        ((conteoSiguiente / conteoActual) - 1.0) * 100.0
                    } else if (conteoSiguiente > 0.0) {
                        100.0
                    } else {
                        0.0
                    }

                    KpiVariacionAnual(
                        periodo = "$anioActual-$anioSiguiente",
                        variacion = variacion
                    )
                }
                KpiDetallado(
                    // ¡VICTORIA! Usamos el nombre correcto para la UI
                    nombre = nombreParaMostrar,
                    historicoAnual = historialAnual
                )
            }
            _uiState.update { it.copy(kpisDetallados = kpisDetalladosCalculados, isLoadingHistoricos = false) }
        }
    }

    // --- ¡NUEVO CANAL DE COMUNICACIONES PARA EL DRON! ---

    fun onMensajeParaAdminChanged(mensaje: String) {
        _uiState.update { it.copy(mensajeParaAdmin = mensaje) }
    }

    fun enviarMensajeAlAdmin(incidenciaId: String) {
        // El rol del que envía el mensaje es el que está logueado
        val rolUsuario = adminProfile.rol ?: "OPERADOR_DRON"
        val mensaje = _uiState.value.mensajeParaAdmin
        if (mensaje.isBlank()) return

        viewModelScope.launch {
            try {
                webService.addComentarioToIncidencia(incidenciaId, mensaje, rolUsuario)
                _uiState.update { it.copy(mensajeParaAdmin = "") } // Limpia el cuadro de texto
                refrescarDatosYSeleccion(incidenciaId) // Refresca para mostrar el nuevo mensaje
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error al enviar el mensaje: ${e.message}") }
            }
        }
    }

    private fun actualizarEstadoConNuevosDatos(incidenciasMaster: List<Incidencia>) {
        // 1. FILTRADO POR ROL (Igual que antes)

        val filtradas = filtrarIncidenciasPorAutoridad(incidenciasMaster)


        // 2. CÁLCULO DE MESES (Igual que antes)
        val meses = incidenciasMaster.mapNotNull { it.fechaCreacion }.map {
            val fecha = Date(it)
            "${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}"
        }.distinct().sortedDescending()

        // 3. --- ¡VICTORIA! ACTUALIZACIÓN AUTOMÁTICA DEL DETALLE ---
        _uiState.update { currentState ->
            // Buscamos la versión más fresca de la incidencia que tienes abierta
            val nuevaSeleccion = currentState.selectedIncidencia?.let { current ->
                incidenciasMaster.find { it.id == current.id }
            }
            val nuevaSeleccionDron = currentState.selectedIncidenciaDron?.let { current ->
                incidenciasMaster.find { it.id == current.id }
            }

            currentState.copy(
                incidencias = filtradas,
                mesesDisponibles = meses,
                selectedIncidencia = nuevaSeleccion ?: currentState.selectedIncidencia,
                selectedIncidenciaDron = nuevaSeleccionDron ?: currentState.selectedIncidenciaDron
            )
        }

        val state = _uiState.value
        // ¡ORDEN: Recalcular inteligencia SOLO con lo que el usuario ve!
        if (state.showInformeView) {
            recalcularEstadisticasConFiltrosActuales()
        } else {
            calcularEstadisticasGenerales(filtradas)
            calcularEstadisticasDelitos(filtradas)
        }
    }

    private fun playAlertSound() {
        try {
            // Usamos un sonido de campana/ding profesional desde un CDN confiable.
            // Es un sonido corto y limpio que no satura el canal.
            val audioUrl = "https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3"
            js("new Audio(audioUrl).play()")
        } catch (e: Exception) {
            console.error("Error en el radar sonoro:", e)
        }
    }
    fun exportarIncidenciasCSV() {
        val lista = incidenciasFiltradas.value
        if (lista.isEmpty()) {
            kotlinx.browser.window.alert("No hay incidencias en la tabla para exportar.")
            return
        }

        // 1. CABECERAS (Usando \n real y BOM para caracteres especiales)
        val headers = "ID,Fecha_Creacion,Tipo,Estado,Comuna,Sector,Latitud,Longitud,Descripcion," +
                "Patrulla,Obs_Patrulla,Fecha_Solucion,Tiempo_Respuesta_Min," +
                "Foto_Reporte,Foto_Solucion,Hubo_Detenidos,Cantidad_Detenidos\n"

        // 2. FILAS (Unificación de datos SIG)
        val filas = lista.joinToString("\n") { inc ->
            val id = inc.id.take(8)
            val fecha = inc.fechaCreacion?.let { Date(it).toLocaleString("es-CL") } ?: "N/A"
            val tipo = inc.tipoIncidenciaDisplayName ?: "General"
            val estado = if (inc.estado == "ASIGNADO") "EN_PROCESO" else inc.estado
            val comuna = inc.comunaDisplayName ?: "Arica"
            val sector = (inc.sectorIncidencia ?: "GENERAL").replace(",", ";")
            val lat = inc.ubicacionGPS?.latitude ?: ""
            val lng = inc.ubicacionGPS?.longitude ?: ""

            // Limpieza de texto para evitar que las comas rompan el CSV
            val desc = inc.descripcion.replace(",", ";").replace("\n", " ").replace("\r", " ")
            val patrulla = (inc.nombreSolucionadorAsignado ?: "Sin Asignar").replace(",", ";")
            val obsPatrulla = (inc.observacionSolucionador ?: "N/A").replace(",", ";")
            val fechaSol = inc.fechaSolucion?.let { Date(it).toLocaleString("es-CL") } ?: "N/A"

            val duracionMs = inc.duracionSolucionMs
            val respuestaStr = if (duracionMs != null && duracionMs > 0) {
                val min = duracionMs.toDouble() / 60000.0
                ((min * 10).toInt() / 10.0).toString()
            } else "N/A"

            val fotoInicial = inc.urlImagen ?: "Sin Foto"
            val fotoFinal = inc.urlImagenSolucion ?: "Sin Foto"

            val huboDetenidos = inc.huboDetenidos.toString().uppercase()
            val cantidadDetenidos = inc.cantidadDetenidos

            "$id,$fecha,$tipo,$estado,$comuna,$sector,$lat,$lng,$desc,$patrulla,$obsPatrulla,$fechaSol,$respuestaStr,$fotoInicial,$fotoFinal,$huboDetenidos,$cantidadDetenidos"
        }

        // BOM para que Excel reconozca tildes y eñes
        val contenidoCompleto = "\uFEFF" + headers + filas

        // 3. GATILLO DE DESCARGA REAL (Sintaxis JS Blindada)
        try {
            js("""
                var blob = new Blob([contenidoCompleto], { type: 'text/csv;charset=utf-8;' });
                var link = document.createElement("a");
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "INTELIGENCIA_SIG_ARICA.csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            """)
        } catch (e: Exception) {
            console.error("Error en exportación:", e)
        }
    }

    fun exportarEstadisticasCSV() {
        val state = _uiState.value
        if (state.estadisticas.isEmpty()) {
            kotlinx.browser.window.alert("No hay estadísticas calculadas para exportar.")
            return
        }

        val statsMes = state.estadisticas.first()
        val todosLosTipos = statsMes.desglosePorTipo.sortedByDescending { it.resumen.total }
        
        // 1. CABECERAS
        val headers = "Tipo_Incidencia,Total,Solucionadas,En_Proceso,Rechazadas,Verificadas,Tiempo_Promedio_Solucion_Min,Porcentaje_Cumplimiento\n"

        // 2. FILAS
        val filas = todosLosTipos.joinToString("\n") { tipo ->
            val nombre = tipo.tipoIncidencia
            val resumen = tipo.resumen
            val tiempoMin = if (resumen.tiempoPromedioSolucionMs > 0) {
                ((resumen.tiempoPromedioSolucionMs / 60000.0) * 10).toInt() / 10.0
            } else 0.0
            
            val cumplimiento = if (resumen.total > 0) {
                (resumen.solucionadas.toDouble() / resumen.total.toDouble() * 100).toInt()
            } else 0

            "$nombre,${resumen.total},${resumen.solucionadas},${resumen.enProceso},${resumen.rechazadas},${resumen.verificadas},$tiempoMin,$cumplimiento%"
        }

        // BOM para que Excel reconozca tildes y eñes
        val contenidoCompleto = "\uFEFF" + headers + filas

        try {
            js("""
                var blob = new Blob([contenidoCompleto], { type: 'text/csv;charset=utf-8;' });
                var link = document.createElement("a");
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "ESTADISTICAS_KPI_GESTION.csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            """)
        } catch (e: Exception) {
            console.error("Error en exportación CSV de estadísticas:", e)
        }
    }


    fun onShowGestionDelitosClicked() {
        _uiState.update { it.copy(
            showGestionDelitosView = true,
            selectedIncidencia = null,
            showMapView = false,
            showEstadisticasView = false,
            showDroneView = false,
            showGestionPatrullasView = false,
            showIngresoIncidenciaView = false
        ) }
        cargarCatalogoDelitos()
    }

    fun onGestionDelitosBackClicked() {
        _uiState.update { it.copy(showGestionDelitosView = false) }
    }

    // 2. Re-ubicar de familia
    fun onCambiarFamiliaDelito(delito: DelitoTipificado, nuevaFamilia: String) {
        viewModelScope.launch {
            val modificado = delito.copy(familia = nuevaFamilia)
            // ⚡ ACTUALIZACIÓN OPTIMISTA: Mover localmente antes de Firebase
            _uiState.update { state ->
                val updatedDelitos = state.delitosCatalog.map { if (it.nombre == delito.nombre) modificado else it }
                val updatedDao = state.daoCatalog.map { if (it.nombre == delito.nombre) modificado else it }
                state.copy(delitosCatalog = updatedDelitos, daoCatalog = updatedDao)
            }
            try {
                webService.guardarOCrearDelito(modificado, true)
            } catch (e: Exception) {
                console.error("Error al mover familia: ${e.message}")
                cargarCatalogoDelitos() // Revertir en fallo
            }
        }
    }

    // 3. Reclutar nuevo hallazgo (Versión Corregida Multi-comuna)
    fun onAgregarNuevoDelito(nombre: String, familia: String, refId: String? = null) {
        viewModelScope.launch {
            val state = _uiState.value
            val rolUpper = (adminProfile.rol ?: "").uppercase().trim()
            val esAdminGeneral = rolUpper == "GENERAL"

            // 🛡️ DETERMINACIÓN DE SOBERANÍA TERRITORIAL
            val comunaRefFinal = if (esAdminGeneral) {
                val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                if (found != null) "comunas/${found.id}" else null
            } else {
                adminProfile.comunaAsignadaRef
            }

            val comunaDisplayFinal = if (esAdminGeneral) {
                state.filtroComuna
            } else {
                adminProfile.comunaAsignadaDisplayName
            }

            // 🛡️ REGLA DE ORO: Si no hay comuna destino, abortamos misión.
            if (comunaRefFinal == null) {
                _uiState.update { it.copy(error = "Debe seleccionar una comuna para agregar hallazgos.") }
                return@launch
            }

            val nuevoDelito = waldo.sankan.lineamunicipalkmp.model.DelitoTipificado(
                nombre = nombre,
                familia = familia,
                grupo = familia,
                colorHex = "#1976D2",
                tipoIncidenciaRef = refId,
                comunaAsignadaRef = comunaRefFinal,
                comunaAsignadaDisplayName = comunaDisplayFinal
            )

            // ⚡ MUTACIÓN LOCAL INMEDIATA: Evita el parpadeo de recarga total
            _uiState.update { currentState ->
                val esDao = familia.uppercase() in listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")
                if (esDao) currentState.copy(daoCatalog = currentState.daoCatalog + nuevoDelito)
                else currentState.copy(delitosCatalog = currentState.delitosCatalog + nuevoDelito)
            }

            try {
                webService.guardarOCrearDelito(nuevoDelito, true)
                console.log("Mando Central: Nuevo hallazgo '$nombre' registrado quirúrgicamente en $comunaDisplayFinal.")
            } catch (e: Exception) {
                console.error("Falla al agregar: ${e.message}")
                _uiState.update { it.copy(error = "Error al guardar hallazgo: ${e.message}") }
                cargarCatalogoDelitos() // Reversión en caso de error
            }
        }
    }

    // --- NUEVOS COMANDOS: GESTIÓN DE REFUERZOS ---

    fun onAsignarRefuerzo(incidenciaId: String, solucionadorUid: String) {
        viewModelScope.launch {try {
            val incidencia = todasLasIncidenciasMaestra.find { it.id == incidenciaId } ?: return@launch
            // Añadimos el nuevo UID a la lista actual, evitando duplicados
            val nuevaLista = (incidencia.idUsuariosRefuerzo + solucionadorUid).distinct()

            // Enviamos la orden al WebService
            webService.actualizarIncidencia(incidenciaId, mapOf("idUsuariosRefuerzo" to nuevaLista.toTypedArray()))

            // Refrescamos para que el Admin vea el cambio inmediatamente
            refrescarDatosYSeleccion(incidenciaId)
            console.log("Refuerzo asignado: $solucionadorUid a la misión $incidenciaId")
        } catch (e: Exception) {
            _uiState.update { it.copy(error = "Error al asignar refuerzo: ${e.message}") }
        }
        }
    }

    fun onQuitarRefuerzo(incidenciaId: String, solucionadorUid: String) {
        viewModelScope.launch {
            try {
                val incidencia = todasLasIncidenciasMaestra.find { it.id == incidenciaId } ?: return@launch
                // Filtramos la lista para quitar al desertor
                val nuevaLista = incidencia.idUsuariosRefuerzo.filter { it != solucionadorUid }

                webService.actualizarIncidencia(incidenciaId, mapOf("idUsuariosRefuerzo" to nuevaLista.toTypedArray()))

                refrescarDatosYSeleccion(incidenciaId)
                console.log("Refuerzo retirado: $solucionadorUid de la misión $incidenciaId")
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error al quitar refuerzo: ${e.message}") }
            }
        }
    }

    fun onShowAgregarSectorModal() { _uiState.update { it.copy(showAgregarSectorModal = true) } }
    fun onHideAgregarSectorModal() { _uiState.update { it.copy(showAgregarSectorModal = false) } }

    // --- ¡LA ORDEN DE RECLUTAMIENTO (ERA NACIONAL)! ---
    fun onCrearNuevaPatrulla(nombre: String, rut: String, email: String, contrasena: String) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, error = null) }
            try {
                val state = _uiState.value
                val miRol = (adminProfile.rol ?: "").uppercase().trim()
                
                // 🛡️ IDENTIFICACIÓN TERRITORIAL LIMPIA
                val rawComunaRef = if (adminProfile.rol == "GENERAL") {
                    state.comunas.find { it.comunaDisplayName == state.filtroComuna }?.id ?: ""
                } else {
                    adminProfile.comunaAsignadaRef ?: ""
                }
                
                val idComunaPuro = rawComunaRef.split("/").last()
                val (cRef, cName) = if (adminProfile.rol == "GENERAL") {
                    val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                    Pair(found?.id ?: "", found?.comunaDisplayName ?: "")
                } else {
                    Pair(adminProfile.comunaAsignadaRef ?: "", adminProfile.comunaAsignadaDisplayName ?: "")
                }

                if (idComunaPuro.isBlank()) throw Exception("Debe seleccionar una comuna objetivo.")
                
                // --- RESOLUCIÓN DE IDENTIDAD TÉCNICA (SANKAN PROTOCOL) ---
                val tipoRefFinal = when (miRol) {
                    "DIRECCION_DAO" -> "direccion_dao_$idComunaPuro"
                    "BASURA", "ASEO" -> "basura_$idComunaPuro"
                    "BACHE" -> "bache_$idComunaPuro"
                    "ILUMINACION" -> "iluminacion_$idComunaPuro"
                    "SEMAFORO" -> "semaforo_$idComunaPuro"
                    "AUTO_ABANDONADO" -> "auto_abandonado_$idComunaPuro"
                    "SALVAVIDAS" -> "salvavidas_$idComunaPuro"
                    "SOCIAL_ADMIN" -> "servicio_social_$idComunaPuro"
                    "SEGURIDAD_ADULTO_MAYOR" -> "seguridadadultomayor_$idComunaPuro"
                    "EMERGENCIA_CARRETERA" -> "emergencia_carretera_$idComunaPuro"
                    "SEGURIDAD_ADMIN" -> "seguridad_ciudadana_$idComunaPuro"
                    else -> adminProfile.uidRol ?: "seguridad_ciudadana_$idComunaPuro"
                }

                val tipoDisplayFinal = when(miRol) {
                    "DIRECCION_DAO" -> "DIRECCIÓN DAO"
                    "SEGURIDAD_ADMIN" -> "Seguridad Ciudadana"
                    "SOCIAL_ADMIN" -> "Servicio Social"
                    "SEGURIDAD_ADULTO_MAYOR" -> "Seguridad Adulto Mayor"
                    "EMERGENCIA_CARRETERA" -> "Emergencia Carretera"
                    "BASURA", "ASEO" -> "Basura"
                    "BACHE" -> "Bache"
                    "ILUMINACION" -> "Iluminación"
                    "SEMAFORO" -> "Semáforo"
                    "AUTO_ABANDONADO" -> "Auto Abandonado"
                    "SALVAVIDAS" -> "Salvavidas"
                    "COMUNAL", "GENERAL" -> "Servicio Comunal"
                    else -> adminProfile.nombre ?: "Servicio Comunal"
                }

                webService.crearNuevoSolucionadorEspecializado(
                    nombre, rut, email, contrasena,
                    tipoRef = tipoRefFinal,
                    tipoDisplay = tipoDisplayFinal,
                    comunaRef = cRef,
                    comunaDisplay = cName
                )
                
                // 🔄 RECARGA Y LIMPIEZA
                _uiState.update { it.copy(showAgregarPatrullaModal = false, isLoading = false) }
                cargarDatosDeGestion()
                console.log("Mando Central: Patrulla $nombre reclutada exitosamente.")
            } catch (e: Exception) {
                console.error("Falla en reclutamiento:", e)
                _uiState.update { it.copy(isLoading = false, error = "Error al crear patrulla: ${e.message}") }
            }
        }
    }

    // --- 🛡️ MANIOBRA DE MANTENIMIENTO: REPARACIÓN DE IDENTIDADES ---
    fun onEjecutarNormalizacionIdentidades() {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                webService.normalizarIdentidadesSolucionadores()
                cargarDatosDeGestion()
                _uiState.update { it.copy(isLoading = false) }
                console.log("Mando Central: Identidades de solucionadores normalizadas con éxito.")
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Falla en normalización: ${e.message}") }
            }
        }
    }

    // --- BLOQUE DE UNIFICACIÓN TERRITORIAL (SECTORES) ---
    fun onCrearNuevoSector(nombre: String) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                val state = _uiState.value
                val miRol = (adminProfile.rol ?: "").uppercase().trim()
                
                // 🛡️ IDENTIFICACIÓN TERRITORIAL PARA CUADRANTES
                val (comunaRef, comunaDisplay) = if (adminProfile.rol == "GENERAL") {
                    val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                    Pair(found?.id ?: "", found?.comunaDisplayName ?: "")
                } else {
                    Pair(adminProfile.comunaAsignadaRef ?: "", adminProfile.comunaAsignadaDisplayName ?: "")
                }

                if (comunaRef.isBlank()) throw Exception("Debe seleccionar una comuna objetivo.")

                // 🛡️ DOCTRINA DE UNIFICACIÓN TOTAL: 
                // Todos los servicios comparten la misma matriz territorial (Cuadrantes Plan Carabineros).
                val tipoRefFinal = "TERRITORIO_ESTANDAR"
                val tipoDisplayFinal = "Matriz Urbana Unificada"

                webService.crearNuevoSector(
                    nombre = nombre,
                    tipoRef = tipoRefFinal,
                    tipoDisplay = tipoDisplayFinal,
                    comunaRef = comunaRef,
                    comunaDisplay = comunaDisplay
                )
                
                cargarDatosDeGestion()
                _uiState.update { it.copy(showAgregarSectorModal = false, isLoading = false) }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error al crear sector: ${e.message}") }
            }
        }
    }

    fun onEliminarSector(id: String) {
        if (window.confirm("¿Está seguro de eliminar este sector? Las patrullas asignadas quedarán en 'GENERAL'.")) {
            viewModelScope.launch {
                try {
                    webService.eliminarSector(id)
                    cargarDatosDeGestion()
                } catch (e: Exception) {
                    console.error("Error al eliminar sector:", e)
                }
            }
        }
    }

    fun onCambiarEstadoSector(id: String, estadoActual: Boolean) {
        viewModelScope.launch {
            try {
                webService.actualizarEstadoSector(id, !estadoActual)
                cargarDatosDeGestion()
            } catch (e: Exception) {
                console.error("Error al cambiar estado sector:", e)
            }
        }
    }

    fun onActualizarNombreSector(id: String, nuevoNombre: String) {
        viewModelScope.launch {
            try {
                webService.actualizarNombreSector(id, nuevoNombre)
                cargarDatosDeGestion()
            } catch (e: Exception) {
                console.error("Error al actualizar nombre sector:", e)
            }
        }
    }

    fun cargarDatosDeGestion() {
        viewModelScope.launch {
            try {
                _uiState.update { it.copy(isLoading = true) }
                
                val state = _uiState.value
                val admin = adminProfile
                
                // 🛡️ IDENTIFICACIÓN TERRITORIAL: 
                // Si es General, usa la comuna filtrada. Si es Comunal, la suya.
                val targetComunaRef = if (admin.rol == "GENERAL") {
                    val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                    found?.id
                } else {
                    admin.comunaAsignadaRef
                }

                if (targetComunaRef == null) {
                    _uiState.update { it.copy(isLoading = false, solucionadores = emptyList(), sectores = emptyList()) }
                    return@launch
                }

                val masterSectores = webService.fetchAllSectores(comunaRef = targetComunaRef)
                val miRol = (admin.rol ?: "").uppercase().trim()

                // --- 🛡️ DOCTRINA DE PERSISTENCIA: Cargamos todos los sectores para permitir su activación/desactivación ---
                val misSectores = masterSectores

                val masterSolucionadores = webService.fetchAllSolucionadores(comunaRef = targetComunaRef)

                // --- FILTRADO DE SOLUCIONADORES SOBERANOS ---
                val misSolucionadores = when {
                    miRol == "GENERAL" || miRol == "OPERADORA" || miRol == "COMUNAL" -> masterSolucionadores
                    miRol == "SEGURIDAD_ADMIN" -> {
                        masterSolucionadores.filter { p ->
                            val ref = (p.tipoIncidenciaAsignadoRef ?: "").lowercase()
                            ref.contains("seguridad") || ref.contains("vdmmnzusszd8hanmfr4s")
                        }
                    }
                    miRol in listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO") -> {
                        masterSolucionadores.filter { p ->
                            val ref = (p.tipoIncidenciaAsignadoRef ?: "").lowercase()
                            val esSeguridad = ref.contains("seguridad") || ref.contains("vdmmnzusszd8hanmfr4s")
                            
                            if (miRol == "DIRECCION_DAO") {
                                !esSeguridad
                            } else {
                                // Mapeo de búsqueda por palabra clave para DAO
                                val keyword = when(miRol) {
                                    "BASURA", "ASEO" -> "basura"
                                    "BACHE" -> "bache"
                                    "ILUMINACION" -> "ilumina"
                                    "SEMAFORO" -> "semaforo"
                                    "AUTO_ABANDONADO" -> "auto"
                                    else -> miRol.lowercase()
                                }
                                ref.contains(keyword)
                            }
                        }
                    }
                    else -> masterSolucionadores.filter { p ->
                        val ref = (p.tipoIncidenciaAsignadoRef ?: "").lowercase()
                        val keyword = when(miRol) {
                            "SOCIAL_ADMIN" -> "social"
                            "SEGURIDAD_ADULTO_MAYOR" -> "adultomayor"
                            "EMERGENCIA_CARRETERA" -> "carretera"
                            "SALVAVIDAS" -> "salvavida"
                            else -> miRol.lowercase()
                        }
                        ref.contains(keyword) || (admin.uidRol != null && ref == admin.uidRol!!.lowercase())
                    }
                }

                console.log("Mando Central: Datos territoriales cargados para $miRol en $targetComunaRef")
                _uiState.update { it.copy(sectores = misSectores, solucionadores = misSolucionadores, isLoading = false) }
            } catch (e: Exception) { _uiState.update { it.copy(isLoading = false) } }
        }
    }


    fun onCambiarEstadoServicio(tipo: TipoIncidencia, estaActivoActual: Boolean) {
        viewModelScope.launch {
            val nuevoEstado = !estaActivoActual
            val state = _uiState.value
            val esGeneral = (adminProfile.rol ?: "").uppercase() == "GENERAL"

            // 🛡️ SOBERANÍA TERRITORIAL PARA LA RECARGA
            val comunaRefFinal = if (esGeneral) {
                val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                if (found != null) "comunas/${found.id}" else null
            } else {
                adminProfile.comunaAsignadaRef
            }

            // ⚡ ACTUALIZACIÓN OPTIMISTA: Reflejo instantáneo en la UI para evitar esperas
            _uiState.update { currentState ->
                currentState.copy(
                    tiposIncidencia = currentState.tiposIncidencia.map {
                        if (it.id == tipo.id) it.copy(estaActivo = nuevoEstado) else it
                    }
                )
            }
            try {
                webService.cambiarEstadoTipoIncidencia(tipo, nuevoEstado)
                
                // 🔄 RECARGA INTELIGENTE: Respeta el filtro de comuna si existe
                val updated = webService.fetchAllTiposIncidencia(comunaRef = comunaRefFinal)
                _uiState.update { it.copy(tiposIncidencia = updated) }
                console.log("Servicio '${tipo.nombre}' actualizado y recargado con filtro: ${comunaRefFinal ?: "CHILE"}")
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Falla al actualizar servicio: ${e.message}") }
                fetchAllData() // Reversión total en caso de error
            }
        }
    }

    fun onCambiarEstadoComuna(comuna: Comuna, estaActivaActual: Boolean) {
        viewModelScope.launch {
            val nuevoEstado = !estaActivaActual
            
            // ⚡ ACTUALIZACIÓN OPTIMISTA: Reflejo instantáneo en la UI
            _uiState.update { currentState ->
                currentState.copy(
                    comunas = currentState.comunas.map {
                        if (it.id == comuna.id) it.copy(estaActiva = nuevoEstado) else it
                    }
                )
            }

            try {
                // 📡 PERSISTENCIA EN FIRESTORE
                webService.actualizarEstadoComuna(comuna.id, nuevoEstado)
                console.log("Mando Central: Comuna '${comuna.comunaDisplayName}' actualizada a: $nuevoEstado")
            } catch (e: Exception) {
                // 🛡️ REVERSIÓN EN CASO DE FALLA
                _uiState.update { it.copy(error = "Falla al actualizar comuna: ${e.message}") }
                
                // Recargamos todos los datos para asegurar consistencia
                fetchAllData()
            }
        }
    }

    fun onCambiarAccesoNoticias(comuna: Comuna, habilitadoActual: Boolean) {
        viewModelScope.launch {
            val nuevoEstado = !habilitadoActual
            _uiState.update { currentState ->
                currentState.copy(
                    comunas = currentState.comunas.map {
                        if (it.id == comuna.id) it.copy(noticiasHabilitadas = nuevoEstado) else it
                    }
                )
            }
            try {
                webService.actualizarAccesoNoticiasComuna(comuna.id, nuevoEstado)
                console.log("Facturación: Servicio de noticias para '${comuna.comunaDisplayName}' -> $nuevoEstado")
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error al actualizar facturación de noticias: ${e.message}") }
                fetchAllData()
            }
        }
    }

    fun onActualizarLimiteNoticias(comuna: Comuna, nuevoLimite: Int) {
        viewModelScope.launch {
            _uiState.update { currentState ->
                currentState.copy(
                    comunas = currentState.comunas.map {
                        if (it.id == comuna.id) it.copy(noticiasHabilitadas = true, noticiasMensualesLimite = nuevoLimite) else it
                    }
                )
            }
            try {
                webService.actualizarLimiteNoticiasComuna(comuna.id, nuevoLimite)
                // Si aumentamos el límite, nos aseguramos de que esté habilitado
                if (!comuna.noticiasHabilitadas) {
                    webService.actualizarAccesoNoticiasComuna(comuna.id, true)
                }
                console.log("Facturación: Límite de noticias para '${comuna.comunaDisplayName}' -> $nuevoLimite")
            } catch (e: Exception) {
                _uiState.update { it.copy(error = "Error al actualizar límite de noticias: ${e.message}") }
                fetchAllData()
            }
        }
    }

    // --- BLOQUE DE GESTIÓN DE SERVICIOS URBANOS ---

    fun onShowGestionServiciosClicked() {
        _uiState.update { it.copy(
            showGestionServiciosView = true,
            selectedIncidencia = null,
            showMapView = false,
            showEstadisticasView = false,
            showInformeView = false,
            showDroneView = false,
            showGestionPatrullasView = false,
            showIngresoIncidenciaView = false
        ) }
    }

    fun onGestionServiciosBackClicked() {
        _uiState.update { it.copy(showGestionServiciosView = false) }
    }

    fun onShowGestionComunasClicked() {
        _uiState.update { it.copy(
            showGestionComunasView = true,
            selectedIncidencia = null,
            showMapView = false,
            showEstadisticasView = false,
            showInformeView = false,
            showDroneView = false,
            showGestionPatrullasView = false,
            showIngresoIncidenciaView = false
        ) }
    }

    fun onGestionComunasBackClicked() {
        _uiState.update { it.copy(showGestionComunasView = false) }
    }
    fun onShowAgregarServicioModal() { _uiState.update { it.copy(showAgregarServicioModal = true) } }
    fun onHideAgregarServicioModal() { _uiState.update { it.copy(showAgregarServicioModal = false) } }

    fun onCrearNuevoServicio(nombre: String, nombreDisplay: String, depto: String, cRef: String?, cName: String?) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                // 🛡️ ADN MAESTRO: Pasamos explícitamente el departamento y la comuna destino
                webService.crearNuevoTipoIncidencia(
                    nombre = nombre,
                    nombreDisplay = nombreDisplay,
                    admin = adminProfile,
                    departamento = depto,
                    comunaRef = cRef,
                    comunaNombre = cName
                )
                
                // Refrescamos con el filtro actual para que el nuevo servicio aparezca de inmediato
                fetchAllData()
                
                _uiState.update { it.copy(showAgregarServicioModal = false, isLoading = false) }
                console.log("Mando Central: Nuevo servicio '$nombreDisplay' desplegado en $cName ($depto)")
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error al crear servicio: ${e.message}") }
            }
        }
    }
    fun onImagenManualSeleccionada(file: org.w3c.files.File?) {
        _uiState.update { it.copy(imagenSeleccionada = file) }
    }

    // --- EDICIÓN Y ELIMINACIÓN DE SERVICIOS ---

    fun onShowEditarServicio(tipo: TipoIncidencia) {
        _uiState.update { it.copy(showEditarServicioModal = true, servicioAEditar = tipo) }
    }

    fun onHideEditarServicio() {
        _uiState.update { it.copy(showEditarServicioModal = false, servicioAEditar = null) }
    }

    fun inyectarDelitosComunaActual() {
        viewModelScope.launch {
            try {
                val state = _uiState.value
                val admin = state.rolAdmin
                if (admin != null) {
                    _uiState.update { it.copy(isLoading = true) }
                    
                    // 🛡️ MISMA LÓGICA DE PUNTERÍA: Usar filtro si es General
                    val (targetRef, targetName) = if (admin.rol == "GENERAL") {
                        val seleccionada = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                        Pair(seleccionada?.id ?: admin.comunaAsignadaRef, seleccionada?.comunaDisplayName ?: admin.comunaAsignadaDisplayName)
                    } else {
                        Pair(admin.comunaAsignadaRef, admin.comunaAsignadaDisplayName)
                    }

                    val finalRef = targetRef ?: ""
                    val finalName = targetName ?: "Sin Nombre"

                    if (finalRef.isBlank()) {
                         _uiState.update { it.copy(isLoading = false, error = "No se pudo determinar la comuna objetivo.") }
                         return@launch
                    }

                    console.log("🚀 ADN MAESTRO (Seguridad): Sincronizando delitos en $finalName")
                    webService.seedFullCommune(finalRef, finalName)
                    cargarCatalogoDelitos()
                    fetchAllData()
                    
                    _uiState.update { it.copy(isLoading = false) }
                    window.alert("¡ÉXITO! Catálogo de Seguridad sincronizado para $finalName")
                }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error al inyectar delitos: ${e.message}") }
            }
        }
    }

    // --- 🇨🇱 NUEVO COMANDO: DESPLIEGUE TERRITORIAL NACIONAL ---
    fun ejecutarSiembraNacional() {
        if (window.confirm("¿Desea cargar todas las regiones y comunas base de Chile?\n\n(Las nuevas comunas nacerán desactivadas)")) {
            viewModelScope.launch {
                try {
                    _uiState.update { it.copy(isLoading = true) }
                    // 🛡️ SANKAN PROTOCOL: Primero sembramos los moldes Globales (Parrilla Nacional)
                    webService.seedGlobalTemplates()
                    // Luego el territorio
                    webService.seedNationalTerritory()
                    fetchAllData() // Refrescamos todo el país
                    _uiState.update { it.copy(isLoading = false) }
                    window.alert("✅ CHILE DESPLEGADO: La Parrilla Nacional y el territorio han sido cargados exitosamente.")
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = e.message) }
                }
            }
        }
    }

    fun inyectarTodoDAO() {
        viewModelScope.launch {
            try {
                val state = _uiState.value
                val admin = state.rolAdmin
                
                // 🛡️ BLOQUEO DE SOBERANÍA: El General ya no puede disparar esta función.
                if (admin == null || admin.rol == "GENERAL") {
                    window.alert("Acceso Restringido: La siembra solo puede ser ejecutada por el Administrador Comunal.")
                    return@launch
                }

                _uiState.update { it.copy(isLoading = true) }
                val targetRef = admin.comunaAsignadaRef
                val targetName = admin.comunaAsignadaDisplayName

                    val finalRef = targetRef ?: ""
                    val finalName = targetName ?: "Sin Nombre"
                    
                    if (finalRef.isBlank()) {
                         _uiState.update { it.copy(isLoading = false, error = "No se pudo determinar la comuna objetivo.") }
                         return@launch
                    }

                    console.log("🚀 ADN MAESTRO: Desplegando en $finalName ($finalRef)")

                    // Delegamos en la función maestra
                    webService.seedFullCommune(finalRef, finalName)
                    
                    // Forzamos recarga total para que la UI reaccione
                    fetchAllData()
                    
                    _uiState.update { it.copy(isLoading = false) }
                    window.alert("¡ÉXITO! $finalName inicializada correctamente.")

            } catch (e: Exception) {
                console.error("Falla en siembra integral:", e)
                _uiState.update { it.copy(isLoading = false, error = "Falla en siembra: ${e.message}") }
            }
        }
    }

    // --- 🛡️ NUEVO COMANDO: SIEMBRA DE GABINETE MUNICIPAL (Soberanía Directa) ---
    fun inyectarGabineteComunaActual(comunaSeleccionada: waldo.sankan.lineamunicipalkmp.model.Comuna? = null) {
        viewModelScope.launch {
            try {
                val state = _uiState.value
                val admin = state.rolAdmin
                if (admin != null) {
                    _uiState.update { it.copy(isLoading = true) }
                    
                    // Si pasamos una comuna por parámetro (desde la card), usamos esa.
                    // Si no, intentamos usar el filtro (para compatibilidad).
                    val targetRef = comunaSeleccionada?.id ?: state.comunas.find { it.comunaDisplayName == state.filtroComuna }?.id
                    val targetName = comunaSeleccionada?.comunaDisplayName ?: state.filtroComuna

                    if (!targetRef.isNullOrBlank()) {
                        console.log("🚀 ADN MAESTRO: Sembrando Gabinete en $targetName ($targetRef)")
                        webService.seedGabineteIntegral(targetRef!!, targetName ?: "Sin Nombre")
                        
                        _uiState.update { it.copy(isLoading = false) }
                        window.alert("✅ ¡GABINETE SEMBRADO! Las 7 credenciales base para $targetName ya están en Firestore.")
                    } else {
                        _uiState.update { it.copy(isLoading = false, error = "No se pudo identificar la comuna objetivo.") }
                    }
                }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error en siembra: ${e.message}") }
            }
        }
    }

    fun onConfirmarEdicionServicio(tipoId: String, nuevoNombre: String) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true) }
            try {
                webService.actualizarNombreServicio(tipoId, nuevoNombre)
                fetchAllData() // Recarga suministros
                _uiState.update { it.copy(showEditarServicioModal = false, servicioAEditar = null, isLoading = false) }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Falla al editar: ${e.message}") }
            }
        }
    }

    // --- BUSQUE LA FUNCIÓN onEliminarServicio Y DÉJELA ASÍ ---
    fun onEliminarServicio(tipoId: String) {
        // Usamos el confirm de la nueva librería para seguridad técnica
        if (window.confirm("¿Está seguro de eliminar este servicio? Esta acción es irreversible.")) {
            viewModelScope.launch {
                _uiState.update { it.copy(isLoading = true) }
                try {
                    webService.eliminarTipoIncidencia(tipoId)
                    fetchAllData()
                    _uiState.update { it.copy(isLoading = false) }
                } catch (e: Exception) {
                    _uiState.update { it.copy(isLoading = false, error = "Falla al eliminar: ${e.message}") }
                }
            }
        }
    }

    fun sembrarComunaActual() {
        viewModelScope.launch {
            try {
                val state = _uiState.value
                val admin = state.rolAdmin
                
                // Determinamos el blanco de la siembra:
                // Si es GENERAL, usamos la comuna seleccionada en el filtro.
                // Si es COMUNAL, usamos su propia comuna asignada.
                val (targetRef, targetName) = if (admin?.rol == "GENERAL") {
                    val seleccionada = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                    Pair(seleccionada?.id, seleccionada?.comunaDisplayName)
                } else {
                    Pair(admin?.comunaAsignadaRef, admin?.comunaAsignadaDisplayName)
                }

                if (!targetRef.isNullOrBlank()) {
                    _uiState.update { it.copy(isLoading = true) }
                    webService.seedFullCommune(targetRef!!, targetName ?: "Sin Nombre")
                    fetchAllData()
                    _uiState.update { it.copy(isLoading = false) }
                    console.log("Mando Central: Siembra completada exitosamente para $targetName")
                } else {
                    _uiState.update { it.copy(error = "Debe seleccionar una comuna válida para realizar la siembra.") }
                }
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = "Error en siembra: ${e.message}") }
            }
        }
    }

    // --- FUNCIÓN LOGOUT DISCIPLINADA ---
    fun logout() {
        viewModelScope.launch {
            try {
                webService.signOut()
                // ¡LA CLAVE! Avisamos que la sesión terminó.
                // Esto disparará automáticamente el refresco en el LoginViewModel.
                onSessionClosed()
            } catch (e: Exception) {
                console.error("Error al cerrar sesión: ${e.message}")
            }
        }
    }
    fun onAgregarNuevoDelitoManual(nombre: String, familia: String, refId: String?) {
        viewModelScope.launch {
            val state = _uiState.value
            val rolUpper = (adminProfile.rol ?: "").uppercase().trim()
            val esAdminGeneral = rolUpper == "GENERAL"

            // 🛡️ DETERMINACIÓN DE SOBERANÍA TERRITORIAL
            val comunaRefFinal = if (esAdminGeneral) {
                val found = state.comunas.find { it.comunaDisplayName == state.filtroComuna }
                if (found != null) "comunas/${found.id}" else null
            } else {
                adminProfile.comunaAsignadaRef
            }

            val comunaDisplayFinal = if (esAdminGeneral) {
                state.filtroComuna
            } else {
                adminProfile.comunaAsignadaDisplayName
            }

            // 🛡️ REGLA DE ORO: Si no hay comuna destino, abortamos misión.
            if (comunaRefFinal == null) {
                _uiState.update { it.copy(error = "Debe seleccionar una comuna para agregar hallazgos.") }
                return@launch
            }

            val nuevoDelito = waldo.sankan.lineamunicipalkmp.model.DelitoTipificado(
                nombre = nombre,
                familia = familia,
                grupo = familia,
                colorHex = "#1976D2",
                tipoIncidenciaRef = refId,
                comunaAsignadaRef = comunaRefFinal,
                comunaAsignadaDisplayName = comunaDisplayFinal
            )

            // ⚡ MUTACIÓN LOCAL INMEDIATA
            _uiState.update { currentState ->
                val esDao = familia.uppercase() in listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")
                if (esDao) currentState.copy(daoCatalog = currentState.daoCatalog + nuevoDelito)
                else currentState.copy(delitosCatalog = currentState.delitosCatalog + nuevoDelito)
            }

            try {
                webService.guardarOCrearDelito(nuevoDelito, true)
                console.log("Mando Central: Nuevo hallazgo '$nombre' registrado en $comunaDisplayFinal.")
            } catch (e: Exception) {
                console.error("Falla al guardar: ${e.message}")
                _uiState.update { it.copy(error = "Error al guardar hallazgo: ${e.message}") }
                cargarCatalogoDelitos() // Rollback
            }
        }
    }

    // --- 📢 MANDO CENTRAL: COMANDOS DE AVISO ---
    fun publicarAvisoNacional() {
        val titulo = window.prompt("Ingrese Título del Comunicado Nacional:", "NUEVO SERVICIO DISPONIBLE")
        if (titulo.isNullOrBlank()) return
        
        val contenido = window.prompt("Ingrese Mensaje para los Administradores:", "Se ha habilitado un nuevo servicio en la Parrilla Nacional. Por favor, sincronice su territorio.")
        if (contenido.isNullOrBlank()) return

        viewModelScope.launch {
            try {
                _uiState.update { it.copy(isLoading = true) }
                webService.publicarAvisoNacional(titulo, contenido)
                val nuevoAviso = webService.fetchAvisoNacional()
                _uiState.update { it.copy(avisoNacional = nuevoAviso, isLoading = false) }
                window.alert("✅ Aviso enviado a todos los administradores del país.")
            } catch (e: Exception) {
                _uiState.update { it.copy(isLoading = false, error = e.message) }
            }
        }
    }

    fun desactivarAvisoNacional() {
        viewModelScope.launch {
            try {
                webService.desactivarAvisoNacional()
                _uiState.update { it.copy(avisoNacional = null) }
            } catch (e: Exception) {
                console.error("Error al desactivar aviso:", e)
            }
        }
    }

    fun onShowPlanCuadranteModal() {
        _uiState.update { it.copy(showPlanCuadranteModal = true) }
    }

    fun onHidePlanCuadranteModal() {
        _uiState.update { it.copy(showPlanCuadranteModal = false) }
    }
}

// Archivo: AdminPanelViewModel.kt -> cargarCatalogoDelitos()


